var items = {
  "block.minecraft.acacia_button": "Butang Akasia",
  "block.minecraft.acacia_door": "Pintu Kayu Akasia",
  "block.minecraft.acacia_fence": "Pagar Akasia",
  "block.minecraft.acacia_fence_gate": "Pintu Pagar Akasia",
  "block.minecraft.acacia_hanging_sign": "Papan Tanda Bergantung Akasia",
  "block.minecraft.acacia_leaves": "Daun Akasia",
  "block.minecraft.acacia_log": "Kayu Balak Akasia",
  "block.minecraft.acacia_planks": "Papan Kayu Akasia",
  "block.minecraft.acacia_pressure_plate": "Plat Tekanan Akasia",
  "block.minecraft.acacia_sapling": "Anak Pokok Akasia",
  "block.minecraft.acacia_shelf": "Rak Akasia",
  "block.minecraft.acacia_sign": "Papan Tanda Akasia",
  "block.minecraft.acacia_slab": "Papak Akasia",
  "block.minecraft.acacia_stairs": "Tangga Akasia",
  "block.minecraft.acacia_trapdoor": "Pintu Kolong Akasia",
  "block.minecraft.acacia_wall_hanging_sign": "Papan Tanda Bergantung Dinding Akasia",
  "block.minecraft.acacia_wall_sign": "Papan Tanda Dinding Akasia",
  "block.minecraft.acacia_wood": "Kayu Akasia",
  "block.minecraft.activator_rail": "Landasan Pengaktif",
  "block.minecraft.air": "Udara",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Blok Batu Kecubung",
  "block.minecraft.amethyst_cluster": "Gugusan Batu Kecubung",
  "block.minecraft.ancient_debris": "Puing Purba",
  "block.minecraft.andesite": "Andesit",
  "block.minecraft.andesite_slab": "Papak Andesit",
  "block.minecraft.andesite_stairs": "Tangga Andesit",
  "block.minecraft.andesite_wall": "Tembok Andesit",
  "block.minecraft.anvil": "Andas",
  "block.minecraft.attached_melon_stem": "Batang Tembikai Terhubung",
  "block.minecraft.attached_pumpkin_stem": "Batang Labu Terhubung",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Daun Azalea",
  "block.minecraft.azure_bluet": "Azure Bluet",
  "block.minecraft.bamboo": "Buluh",
  "block.minecraft.bamboo_block": "Blok Buluh",
  "block.minecraft.bamboo_button": "Butang Buluh",
  "block.minecraft.bamboo_door": "Pintu Buluh",
  "block.minecraft.bamboo_fence": "Pagar Buluh",
  "block.minecraft.bamboo_fence_gate": "Pintu Pagar Buluh",
  "block.minecraft.bamboo_hanging_sign": "Papan Tanda Bergantung Buluh",
  "block.minecraft.bamboo_mosaic": "Anyaman Buluh",
  "block.minecraft.bamboo_mosaic_slab": "Papak Anyaman Buluh",
  "block.minecraft.bamboo_mosaic_stairs": "Tangga Anyaman Buluh",
  "block.minecraft.bamboo_planks": "Papan Buluh",
  "block.minecraft.bamboo_pressure_plate": "Plat Tekanan Buluh",
  "block.minecraft.bamboo_sapling": "Rebung",
  "block.minecraft.bamboo_shelf": "Rak Buluh",
  "block.minecraft.bamboo_sign": "Papan Tanda Buluh",
  "block.minecraft.bamboo_slab": "Papak Buluh",
  "block.minecraft.bamboo_stairs": "Tangga Buluh",
  "block.minecraft.bamboo_trapdoor": "Pintu Kolong Buluh",
  "block.minecraft.bamboo_wall_hanging_sign": "Papan Tanda Bergantung Dinding Buluh",
  "block.minecraft.bamboo_wall_sign": "Papan Tanda Dinding Buluh",
  "block.minecraft.banner.base.black": "Latar Hitam Penuh",
  "block.minecraft.banner.base.blue": "Latar Biru Penuh",
  "block.minecraft.banner.base.brown": "Latar Perang Penuh",
  "block.minecraft.banner.base.cyan": "Latar Sian Penuh",
  "block.minecraft.banner.base.gray": "Latar Kelabu Penuh",
  "block.minecraft.banner.base.green": "Latar Hijau Penuh",
  "block.minecraft.banner.base.light_blue": "Latar Biru Muda Penuh",
  "block.minecraft.banner.base.light_gray": "Latar Kelabu Muda Penuh",
  "block.minecraft.banner.base.lime": "Latar Hijau Muda Penuh",
  "block.minecraft.banner.base.magenta": "Latar Magenta Penuh",
  "block.minecraft.banner.base.orange": "Latar Jingga Penuh",
  "block.minecraft.banner.base.pink": "Latar Merah Jambu Penuh",
  "block.minecraft.banner.base.purple": "Latar Ungu Penuh",
  "block.minecraft.banner.base.red": "Latar Merah Penuh",
  "block.minecraft.banner.base.white": "Latar Putih Penuh",
  "block.minecraft.banner.base.yellow": "Latar Kuning Penuh",
  "block.minecraft.banner.border.black": "Bingkai Hitam",
  "block.minecraft.banner.border.blue": "Bingkai Biru",
  "block.minecraft.banner.border.brown": "Bingkai Perang",
  "block.minecraft.banner.border.cyan": "Bingkai Sian",
  "block.minecraft.banner.border.gray": "Bingkai Kelabu",
  "block.minecraft.banner.border.green": "Bingkai Hijau",
  "block.minecraft.banner.border.light_blue": "Bingkai Biru Muda",
  "block.minecraft.banner.border.light_gray": "Bingkai Kelabu Muda",
  "block.minecraft.banner.border.lime": "Bingkai Hijau Muda",
  "block.minecraft.banner.border.magenta": "Bingkai Magenta",
  "block.minecraft.banner.border.orange": "Bingkai Jingga",
  "block.minecraft.banner.border.pink": "Bingkai Merah Jambu",
  "block.minecraft.banner.border.purple": "Bingkai Ungu",
  "block.minecraft.banner.border.red": "Bingkai Merah",
  "block.minecraft.banner.border.white": "Bingkai Putih",
  "block.minecraft.banner.border.yellow": "Bingkai Kuning",
  "block.minecraft.banner.bricks.black": "Bataan Hitam",
  "block.minecraft.banner.bricks.blue": "Bataan Biru",
  "block.minecraft.banner.bricks.brown": "Bataan Perang",
  "block.minecraft.banner.bricks.cyan": "Bataan Sian",
  "block.minecraft.banner.bricks.gray": "Bataan Kelabu",
  "block.minecraft.banner.bricks.green": "Bataan Hijau",
  "block.minecraft.banner.bricks.light_blue": "Bataan Biru Muda",
  "block.minecraft.banner.bricks.light_gray": "Bataan Kelabu Muda",
  "block.minecraft.banner.bricks.lime": "Bataan Hijau Muda",
  "block.minecraft.banner.bricks.magenta": "Bataan Magenta",
  "block.minecraft.banner.bricks.orange": "Bataan Jingga",
  "block.minecraft.banner.bricks.pink": "Bataan Merah Jambu",
  "block.minecraft.banner.bricks.purple": "Bataan Ungu",
  "block.minecraft.banner.bricks.red": "Bataan Merah",
  "block.minecraft.banner.bricks.white": "Bataan Putih",
  "block.minecraft.banner.bricks.yellow": "Bataan Kuning",
  "block.minecraft.banner.circle.black": "Bulatan Hitam",
  "block.minecraft.banner.circle.blue": "Bulatan Biru",
  "block.minecraft.banner.circle.brown": "Bulatan Perang",
  "block.minecraft.banner.circle.cyan": "Bulatan Sian",
  "block.minecraft.banner.circle.gray": "Bulatan Kelabu",
  "block.minecraft.banner.circle.green": "Bulatan Hijau",
  "block.minecraft.banner.circle.light_blue": "Bulatan Biru Muda",
  "block.minecraft.banner.circle.light_gray": "Bulatan Kelabu Muda",
  "block.minecraft.banner.circle.lime": "Bulatan Hijau Muda",
  "block.minecraft.banner.circle.magenta": "Bulatan Magenta",
  "block.minecraft.banner.circle.orange": "Bulatan Jingga",
  "block.minecraft.banner.circle.pink": "Bulatan Merah Jambu",
  "block.minecraft.banner.circle.purple": "Bulatan Ungu",
  "block.minecraft.banner.circle.red": "Bulatan Merah",
  "block.minecraft.banner.circle.white": "Bulatan Putih",
  "block.minecraft.banner.circle.yellow": "Bulatan Kuning",
  "block.minecraft.banner.creeper.black": "Lambang Creeper Hitam",
  "block.minecraft.banner.creeper.blue": "Lambang Creeper Biru",
  "block.minecraft.banner.creeper.brown": "Lambang Creeper Perang",
  "block.minecraft.banner.creeper.cyan": "Lambang Creeper Sian",
  "block.minecraft.banner.creeper.gray": "Lambang Creeper Kelabu",
  "block.minecraft.banner.creeper.green": "Lambang Creeper Hijau",
  "block.minecraft.banner.creeper.light_blue": "Lambang Creeper Biru Muda",
  "block.minecraft.banner.creeper.light_gray": "Lambang Creeper Kelabu Muda",
  "block.minecraft.banner.creeper.lime": "Lambang Creeper Hijau Muda",
  "block.minecraft.banner.creeper.magenta": "Lambang Creeper Magenta",
  "block.minecraft.banner.creeper.orange": "Lambang Creeper Jingga",
  "block.minecraft.banner.creeper.pink": "Lambang Creeper Merah Jambu",
  "block.minecraft.banner.creeper.purple": "Lambang Creeper Ungu",
  "block.minecraft.banner.creeper.red": "Lambang Creeper Merah",
  "block.minecraft.banner.creeper.white": "Lambang Creeper Putih",
  "block.minecraft.banner.creeper.yellow": "Lambang Creeper Kuning",
  "block.minecraft.banner.cross.black": "Palang Serong Hitam",
  "block.minecraft.banner.cross.blue": "Palang Serong Biru",
  "block.minecraft.banner.cross.brown": "Palang Serong Perang",
  "block.minecraft.banner.cross.cyan": "Palang Serong Sian",
  "block.minecraft.banner.cross.gray": "Palang Serong Kelabu",
  "block.minecraft.banner.cross.green": "Palang Serong Hijau",
  "block.minecraft.banner.cross.light_blue": "Palang Serong Biru Muda",
  "block.minecraft.banner.cross.light_gray": "Palang Serong Kelabu Muda",
  "block.minecraft.banner.cross.lime": "Palang Serong Hijau Muda",
  "block.minecraft.banner.cross.magenta": "Palang Serong Magenta",
  "block.minecraft.banner.cross.orange": "Palang Serong Jingga",
  "block.minecraft.banner.cross.pink": "Palang Serong Merah Jambu",
  "block.minecraft.banner.cross.purple": "Palang Serong Ungu",
  "block.minecraft.banner.cross.red": "Palang Serong Merah",
  "block.minecraft.banner.cross.white": "Palang Serong Putih",
  "block.minecraft.banner.cross.yellow": "Palang Serong Kuning",
  "block.minecraft.banner.curly_border.black": "Bingkai Bergerigi Hitam",
  "block.minecraft.banner.curly_border.blue": "Bingkai Bergerigi Biru",
  "block.minecraft.banner.curly_border.brown": "Bingkai Bergerigi Perang",
  "block.minecraft.banner.curly_border.cyan": "Bingkai Bergerigi Sian",
  "block.minecraft.banner.curly_border.gray": "Bingkai Bergerigi Kelabu",
  "block.minecraft.banner.curly_border.green": "Bingkai Bergerigi Hijau",
  "block.minecraft.banner.curly_border.light_blue": "Bingkai Bergerigi Biru Muda",
  "block.minecraft.banner.curly_border.light_gray": "Bingkai Bergerigi Kelabu Muda",
  "block.minecraft.banner.curly_border.lime": "Bingkai Bergerigi Hijau Muda",
  "block.minecraft.banner.curly_border.magenta": "Bingkai Bergerigi Magenta",
  "block.minecraft.banner.curly_border.orange": "Bingkai Bergerigi Jingga",
  "block.minecraft.banner.curly_border.pink": "Bingkai Bergerigi Merah Jambu",
  "block.minecraft.banner.curly_border.purple": "Bingkai Bergerigi Ungu",
  "block.minecraft.banner.curly_border.red": "Bingkai Bergerigi Merah",
  "block.minecraft.banner.curly_border.white": "Bingkai Bergerigi Putih",
  "block.minecraft.banner.curly_border.yellow": "Bingkai Bergerigi Kuning",
  "block.minecraft.banner.diagonal_left.black": "Belahan Serong Kiri Hitam",
  "block.minecraft.banner.diagonal_left.blue": "Belahan Serong Kiri Biru",
  "block.minecraft.banner.diagonal_left.brown": "Belahan Serong Kiri Perang",
  "block.minecraft.banner.diagonal_left.cyan": "Belahan Serong Kiri Sian",
  "block.minecraft.banner.diagonal_left.gray": "Belahan Serong Kiri Kelabu",
  "block.minecraft.banner.diagonal_left.green": "Belahan Serong Kiri Hijau",
  "block.minecraft.banner.diagonal_left.light_blue": "Belahan Serong Kiri Biru Muda",
  "block.minecraft.banner.diagonal_left.light_gray": "Belahan Serong Kiri Kelabu Muda",
  "block.minecraft.banner.diagonal_left.lime": "Belahan Serong Kiri Hijau Muda",
  "block.minecraft.banner.diagonal_left.magenta": "Belahan Serong Kiri Magenta",
  "block.minecraft.banner.diagonal_left.orange": "Belahan Serong Kiri Jingga",
  "block.minecraft.banner.diagonal_left.pink": "Belahan Serong Kiri Merah Jambu",
  "block.minecraft.banner.diagonal_left.purple": "Belahan Serong Kiri Ungu",
  "block.minecraft.banner.diagonal_left.red": "Belahan Serong Kiri Merah",
  "block.minecraft.banner.diagonal_left.white": "Belahan Serong Kiri Putih",
  "block.minecraft.banner.diagonal_left.yellow": "Belahan Serong Kiri Kuning",
  "block.minecraft.banner.diagonal_right.black": "Belahan Serong Hitam",
  "block.minecraft.banner.diagonal_right.blue": "Belahan Serong Biru",
  "block.minecraft.banner.diagonal_right.brown": "Belahan Serong Perang",
  "block.minecraft.banner.diagonal_right.cyan": "Belahan Serong Sian",
  "block.minecraft.banner.diagonal_right.gray": "Belahan Serong Kelabu",
  "block.minecraft.banner.diagonal_right.green": "Belahan Serong Hijau",
  "block.minecraft.banner.diagonal_right.light_blue": "Belahan Serong Biru Muda",
  "block.minecraft.banner.diagonal_right.light_gray": "Belahan Serong Kelabu Muda",
  "block.minecraft.banner.diagonal_right.lime": "Belahan Serong Hijau Muda",
  "block.minecraft.banner.diagonal_right.magenta": "Belahan Serong Magenta",
  "block.minecraft.banner.diagonal_right.orange": "Belahan Serong Jingga",
  "block.minecraft.banner.diagonal_right.pink": "Belahan Serong Merah Jambu",
  "block.minecraft.banner.diagonal_right.purple": "Belahan Serong Ungu",
  "block.minecraft.banner.diagonal_right.red": "Belahan Serong Merah",
  "block.minecraft.banner.diagonal_right.white": "Belahan Serong Putih",
  "block.minecraft.banner.diagonal_right.yellow": "Belahan Serong Kuning",
  "block.minecraft.banner.diagonal_up_left.black": "Belahan Serong Songsang Hitam",
  "block.minecraft.banner.diagonal_up_left.blue": "Belahan Serong Songsang Biru",
  "block.minecraft.banner.diagonal_up_left.brown": "Belahan Serong Songsang Perang",
  "block.minecraft.banner.diagonal_up_left.cyan": "Belahan Serong Songsang Sian",
  "block.minecraft.banner.diagonal_up_left.gray": "Belahan Serong Songsang Kelabu",
  "block.minecraft.banner.diagonal_up_left.green": "Belahan Serong Songsang Hijau",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Belahan Serong Songsang Biru Muda",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Belahan Serong Songsang Kelabu Muda",
  "block.minecraft.banner.diagonal_up_left.lime": "Belahan Serong Songsang Hijau Muda",
  "block.minecraft.banner.diagonal_up_left.magenta": "Belahan Serong Songsang Magenta",
  "block.minecraft.banner.diagonal_up_left.orange": "Belahan Serong Songsang Jingga",
  "block.minecraft.banner.diagonal_up_left.pink": "Belahan Serong Songsang Merah Jambu",
  "block.minecraft.banner.diagonal_up_left.purple": "Belahan Serong Songsang Ungu",
  "block.minecraft.banner.diagonal_up_left.red": "Belahan Serong Songsang Merah",
  "block.minecraft.banner.diagonal_up_left.white": "Belahan Serong Songsang Putih",
  "block.minecraft.banner.diagonal_up_left.yellow": "Belahan Serong Songsang Kuning",
  "block.minecraft.banner.diagonal_up_right.black": "Belahan Serong Kiri Songsang Hitam",
  "block.minecraft.banner.diagonal_up_right.blue": "Belahan Serong Kiri Songsang Biru",
  "block.minecraft.banner.diagonal_up_right.brown": "Belahan Serong Kiri Songsang Perang",
  "block.minecraft.banner.diagonal_up_right.cyan": "Belahan Serong Kiri Songsang Sian",
  "block.minecraft.banner.diagonal_up_right.gray": "Belahan Serong Kiri Songsang Kelabu",
  "block.minecraft.banner.diagonal_up_right.green": "Belahan Serong Kiri Songsang Hijau",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Belahan Serong Kiri Songsang Biru Muda",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Belahan Serong Kiri Songsang Kelabu Muda",
  "block.minecraft.banner.diagonal_up_right.lime": "Belahan Serong Kiri Songsang Hijau Muda",
  "block.minecraft.banner.diagonal_up_right.magenta": "Belahan Serong Kiri Songsang Magenta",
  "block.minecraft.banner.diagonal_up_right.orange": "Belahan Serong Kiri Songsang Jingga",
  "block.minecraft.banner.diagonal_up_right.pink": "Belahan Serong Kiri Songsang Merah Jambu",
  "block.minecraft.banner.diagonal_up_right.purple": "Belahan Serong Kiri Songsang Ungu",
  "block.minecraft.banner.diagonal_up_right.red": "Belahan Serong Kiri Songsang Merah",
  "block.minecraft.banner.diagonal_up_right.white": "Belahan Serong Kiri Songsang Putih",
  "block.minecraft.banner.diagonal_up_right.yellow": "Belahan Serong Kiri Songsang Kuning",
  "block.minecraft.banner.flow.black": "Aliran Hitam",
  "block.minecraft.banner.flow.blue": "Aliran Biru",
  "block.minecraft.banner.flow.brown": "Aliran Perang",
  "block.minecraft.banner.flow.cyan": "Aliran Sian",
  "block.minecraft.banner.flow.gray": "Aliran Kelabu",
  "block.minecraft.banner.flow.green": "Aliran Hijau",
  "block.minecraft.banner.flow.light_blue": "Aliran Biru Muda",
  "block.minecraft.banner.flow.light_gray": "Aliran Kelabu Muda",
  "block.minecraft.banner.flow.lime": "Aliran Hijau Muda",
  "block.minecraft.banner.flow.magenta": "Aliran Magenta",
  "block.minecraft.banner.flow.orange": "Aliran Jingga",
  "block.minecraft.banner.flow.pink": "Aliran Merah Jambu",
  "block.minecraft.banner.flow.purple": "Aliran Ungu",
  "block.minecraft.banner.flow.red": "Aliran Merah",
  "block.minecraft.banner.flow.white": "Aliran Putih",
  "block.minecraft.banner.flow.yellow": "Aliran Kuning",
  "block.minecraft.banner.flower.black": "Lambang Bunga Hitam",
  "block.minecraft.banner.flower.blue": "Lambang Bunga Biru",
  "block.minecraft.banner.flower.brown": "Lambang Bunga Perang",
  "block.minecraft.banner.flower.cyan": "Lambang Bunga Sian",
  "block.minecraft.banner.flower.gray": "Lambang Bunga Kelabu",
  "block.minecraft.banner.flower.green": "Lambang Bunga Hijau",
  "block.minecraft.banner.flower.light_blue": "Lambang Bunga Biru Muda",
  "block.minecraft.banner.flower.light_gray": "Lambang Bunga Kelabu Muda",
  "block.minecraft.banner.flower.lime": "Lambang Bunga Hijau Muda",
  "block.minecraft.banner.flower.magenta": "Lambang Bunga Magenta",
  "block.minecraft.banner.flower.orange": "Lambang Bunga Jingga",
  "block.minecraft.banner.flower.pink": "Lambang Bunga Merah Jambu",
  "block.minecraft.banner.flower.purple": "Lambang Bunga Ungu",
  "block.minecraft.banner.flower.red": "Lambang Bunga Merah",
  "block.minecraft.banner.flower.white": "Lambang Bunga Putih",
  "block.minecraft.banner.flower.yellow": "Lambang Bunga Kuning",
  "block.minecraft.banner.globe.black": "Glob Hitam",
  "block.minecraft.banner.globe.blue": "Glob Biru",
  "block.minecraft.banner.globe.brown": "Glob Perang",
  "block.minecraft.banner.globe.cyan": "Glob Sian",
  "block.minecraft.banner.globe.gray": "Glob Kelabu",
  "block.minecraft.banner.globe.green": "Glob Hijau",
  "block.minecraft.banner.globe.light_blue": "Glob Biru Muda",
  "block.minecraft.banner.globe.light_gray": "Glob Kelabu Muda",
  "block.minecraft.banner.globe.lime": "Glob Hijau Muda",
  "block.minecraft.banner.globe.magenta": "Glob Magenta",
  "block.minecraft.banner.globe.orange": "Glob Jingga",
  "block.minecraft.banner.globe.pink": "Glob Merah Jambu",
  "block.minecraft.banner.globe.purple": "Glob Ungu",
  "block.minecraft.banner.globe.red": "Glob Merah",
  "block.minecraft.banner.globe.white": "Glob Putih",
  "block.minecraft.banner.globe.yellow": "Glob Kuning",
  "block.minecraft.banner.gradient.black": "Gradien Hitam",
  "block.minecraft.banner.gradient.blue": "Gradien Biru",
  "block.minecraft.banner.gradient.brown": "Gradien Perang",
  "block.minecraft.banner.gradient.cyan": "Gradien Sian",
  "block.minecraft.banner.gradient.gray": "Gradien Kelabu",
  "block.minecraft.banner.gradient.green": "Gradien Hijau",
  "block.minecraft.banner.gradient.light_blue": "Gradien Biru Muda",
  "block.minecraft.banner.gradient.light_gray": "Gradien Kelabu Muda",
  "block.minecraft.banner.gradient.lime": "Gradien Hijau Muda",
  "block.minecraft.banner.gradient.magenta": "Gradien Magenta",
  "block.minecraft.banner.gradient.orange": "Gradien Jingga",
  "block.minecraft.banner.gradient.pink": "Gradien Merah Jambu",
  "block.minecraft.banner.gradient.purple": "Gradien Ungu",
  "block.minecraft.banner.gradient.red": "Gradien Merah",
  "block.minecraft.banner.gradient.white": "Gradien Putih",
  "block.minecraft.banner.gradient.yellow": "Gradien Kuning",
  "block.minecraft.banner.gradient_up.black": "Gradien Pengaki Hitam",
  "block.minecraft.banner.gradient_up.blue": "Gradien Pengaki Biru",
  "block.minecraft.banner.gradient_up.brown": "Gradien Pengaki Perang",
  "block.minecraft.banner.gradient_up.cyan": "Gradien Pengaki Cyan",
  "block.minecraft.banner.gradient_up.gray": "Gradien Pengaki Kelabu",
  "block.minecraft.banner.gradient_up.green": "Gradien Pengaki Hijau",
  "block.minecraft.banner.gradient_up.light_blue": "Gradien Pengaki Biru Muda",
  "block.minecraft.banner.gradient_up.light_gray": "Gradien Pengaki Kelabu Muda",
  "block.minecraft.banner.gradient_up.lime": "Gradien Pengaki Hijau Muda",
  "block.minecraft.banner.gradient_up.magenta": "Gradien Pengaki Magenta",
  "block.minecraft.banner.gradient_up.orange": "Gradien Pengaki Jingga",
  "block.minecraft.banner.gradient_up.pink": "Gradien Pengaki Merah Jambu",
  "block.minecraft.banner.gradient_up.purple": "Gradien Pengaki Ungu",
  "block.minecraft.banner.gradient_up.red": "Gradien Pengaki Merah",
  "block.minecraft.banner.gradient_up.white": "Gradien Pengaki Putih",
  "block.minecraft.banner.gradient_up.yellow": "Gradien Pengaki Kuning",
  "block.minecraft.banner.guster.black": "Pemusar Hitam",
  "block.minecraft.banner.guster.blue": "Pemusar Biru",
  "block.minecraft.banner.guster.brown": "Pemusar Perang",
  "block.minecraft.banner.guster.cyan": "Pemusar Sian",
  "block.minecraft.banner.guster.gray": "Pemusar Kelabu",
  "block.minecraft.banner.guster.green": "Pemusar Hijau",
  "block.minecraft.banner.guster.light_blue": "Pemusar Biru Muda",
  "block.minecraft.banner.guster.light_gray": "Pemusar Kelabu Muda",
  "block.minecraft.banner.guster.lime": "Pemusar Hijau Muda",
  "block.minecraft.banner.guster.magenta": "Pemusar Magenta",
  "block.minecraft.banner.guster.orange": "Pemusar Jingga",
  "block.minecraft.banner.guster.pink": "Pemusar Merah Jambu",
  "block.minecraft.banner.guster.purple": "Pemusar Ungu",
  "block.minecraft.banner.guster.red": "Pemusar Merah",
  "block.minecraft.banner.guster.white": "Pemusar Putih",
  "block.minecraft.banner.guster.yellow": "Pemusar Kuning",
  "block.minecraft.banner.half_horizontal.black": "Belahan Mengufuk Hitam",
  "block.minecraft.banner.half_horizontal.blue": "Belahan Mengufuk Biru",
  "block.minecraft.banner.half_horizontal.brown": "Belahan Mengufuk Perang",
  "block.minecraft.banner.half_horizontal.cyan": "Belahan Mengufuk Sian",
  "block.minecraft.banner.half_horizontal.gray": "Belahan Mengufuk Kelabu",
  "block.minecraft.banner.half_horizontal.green": "Belahan Mengufuk Hijau",
  "block.minecraft.banner.half_horizontal.light_blue": "Belahan Mengufuk Biru Muda",
  "block.minecraft.banner.half_horizontal.light_gray": "Belahan Mengufuk Kelabu Muda",
  "block.minecraft.banner.half_horizontal.lime": "Belahan Mengufuk Hijau Muda",
  "block.minecraft.banner.half_horizontal.magenta": "Belahan Mengufuk Magenta",
  "block.minecraft.banner.half_horizontal.orange": "Belahan Mengufuk Jingga",
  "block.minecraft.banner.half_horizontal.pink": "Belahan Mengufuk Merah Jambu",
  "block.minecraft.banner.half_horizontal.purple": "Belahan Mengufuk Ungu",
  "block.minecraft.banner.half_horizontal.red": "Belahan Mengufuk Merah",
  "block.minecraft.banner.half_horizontal.white": "Belahan Mengufuk Putih",
  "block.minecraft.banner.half_horizontal.yellow": "Belahan Mengufuk Kuning",
  "block.minecraft.banner.half_horizontal_bottom.black": "Belahan Mengufuk Songsang Hitam",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Belahan Mengufuk Songsang Biru",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Belahan Mengufuk Songsang Perang",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Belahan Mengufuk Songsang Sian",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Belahan Mengufuk Songsang Kelabu",
  "block.minecraft.banner.half_horizontal_bottom.green": "Belahan Mengufuk Songsang Hijau",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Belahan Mengufuk Songsang Biru Muda",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Belahan Mengufuk Songsang Kelabu Muda",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Belahan Mengufuk Songsang Hijau Muda",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Belahan Mengufuk Songsang Magenta",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Belahan Mengufuk Songsang Jingga",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Belahan Mengufuk Songsang Merah Jambu",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Belahan Mengufuk Songsang Ungu",
  "block.minecraft.banner.half_horizontal_bottom.red": "Belahan Mengufuk Songsang Merah",
  "block.minecraft.banner.half_horizontal_bottom.white": "Belahan Mengufuk Songsang Putih",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Belahan Mengufuk Songsang Kuning",
  "block.minecraft.banner.half_vertical.black": "Belahan Mencancang Hitam",
  "block.minecraft.banner.half_vertical.blue": "Belahan Mencancang Biru",
  "block.minecraft.banner.half_vertical.brown": "Belahan Mencancang Perang",
  "block.minecraft.banner.half_vertical.cyan": "Belahan Mencancang Sian",
  "block.minecraft.banner.half_vertical.gray": "Belahan Mencancang Kelabu",
  "block.minecraft.banner.half_vertical.green": "Belahan Mencancang Hijau",
  "block.minecraft.banner.half_vertical.light_blue": "Belahan Mencancang Biru Muda",
  "block.minecraft.banner.half_vertical.light_gray": "Belahan Mencancang Kelabu Muda",
  "block.minecraft.banner.half_vertical.lime": "Belahan Mencancang Hijau Muda",
  "block.minecraft.banner.half_vertical.magenta": "Belahan Mencancang Magenta",
  "block.minecraft.banner.half_vertical.orange": "Belahan Mencancang Jingga",
  "block.minecraft.banner.half_vertical.pink": "Belahan Mencancang Merah Jambu",
  "block.minecraft.banner.half_vertical.purple": "Belahan Mencancang Ungu",
  "block.minecraft.banner.half_vertical.red": "Belahan Mencancang Merah",
  "block.minecraft.banner.half_vertical.white": "Belahan Mencancang Putih",
  "block.minecraft.banner.half_vertical.yellow": "Belahan Mencancang Kuning",
  "block.minecraft.banner.half_vertical_right.black": "Belahan Mencancang Songsang Hitam",
  "block.minecraft.banner.half_vertical_right.blue": "Belahan Mencancang Songsang Biru",
  "block.minecraft.banner.half_vertical_right.brown": "Belahan Mencancang Songsang Perang",
  "block.minecraft.banner.half_vertical_right.cyan": "Belahan Mencancang Songsang Sian",
  "block.minecraft.banner.half_vertical_right.gray": "Belahan Mencancang Songsang Kelabu",
  "block.minecraft.banner.half_vertical_right.green": "Belahan Mencancang Songsang Hijau",
  "block.minecraft.banner.half_vertical_right.light_blue": "Belahan Mencancang Songsang Biru Muda",
  "block.minecraft.banner.half_vertical_right.light_gray": "Belahan Mencancang Songsang Kelabu Muda",
  "block.minecraft.banner.half_vertical_right.lime": "Belahan Mencancang Songsang Hijau Muda",
  "block.minecraft.banner.half_vertical_right.magenta": "Belahan Mencancang Songsang Magenta",
  "block.minecraft.banner.half_vertical_right.orange": "Belahan Mencancang Songsang Jingga",
  "block.minecraft.banner.half_vertical_right.pink": "Belahan Mencancang Songsang Merah Jambu",
  "block.minecraft.banner.half_vertical_right.purple": "Belahan Mencancang Songsang Ungu",
  "block.minecraft.banner.half_vertical_right.red": "Belahan Mencancang Songsang Merah",
  "block.minecraft.banner.half_vertical_right.white": "Belahan Mencancang Songsang Putih",
  "block.minecraft.banner.half_vertical_right.yellow": "Belahan Mencancang Songsang Kuning",
  "block.minecraft.banner.mojang.black": "Benda Hitam",
  "block.minecraft.banner.mojang.blue": "Benda Biru",
  "block.minecraft.banner.mojang.brown": "Benda Perang",
  "block.minecraft.banner.mojang.cyan": "Benda Sian",
  "block.minecraft.banner.mojang.gray": "Benda Kelabu",
  "block.minecraft.banner.mojang.green": "Benda Hijau",
  "block.minecraft.banner.mojang.light_blue": "Benda Biru Muda",
  "block.minecraft.banner.mojang.light_gray": "Benda Kelabu Muda",
  "block.minecraft.banner.mojang.lime": "Benda Hijau Muda",
  "block.minecraft.banner.mojang.magenta": "Benda Magenta",
  "block.minecraft.banner.mojang.orange": "Benda Jingga",
  "block.minecraft.banner.mojang.pink": "Benda Merah Jambu",
  "block.minecraft.banner.mojang.purple": "Benda Ungu",
  "block.minecraft.banner.mojang.red": "Benda Merah",
  "block.minecraft.banner.mojang.white": "Benda Putih",
  "block.minecraft.banner.mojang.yellow": "Benda Kuning",
  "block.minecraft.banner.piglin.black": "Muncung Hitam",
  "block.minecraft.banner.piglin.blue": "Muncung Biru",
  "block.minecraft.banner.piglin.brown": "Muncung Perang",
  "block.minecraft.banner.piglin.cyan": "Muncung Sian",
  "block.minecraft.banner.piglin.gray": "Muncung Kelabu",
  "block.minecraft.banner.piglin.green": "Muncung Hijau",
  "block.minecraft.banner.piglin.light_blue": "Muncung Biru Muda",
  "block.minecraft.banner.piglin.light_gray": "Muncung Kelabu Muda",
  "block.minecraft.banner.piglin.lime": "Muncung Hijau Muda",
  "block.minecraft.banner.piglin.magenta": "Muncung Magenta",
  "block.minecraft.banner.piglin.orange": "Muncung Jingga",
  "block.minecraft.banner.piglin.pink": "Muncung Merah Jambu",
  "block.minecraft.banner.piglin.purple": "Muncung Ungu",
  "block.minecraft.banner.piglin.red": "Muncung Merah",
  "block.minecraft.banner.piglin.white": "Muncung Putih",
  "block.minecraft.banner.piglin.yellow": "Muncung Kuning",
  "block.minecraft.banner.rhombus.black": "Rombus Hitam",
  "block.minecraft.banner.rhombus.blue": "Rombus Biru",
  "block.minecraft.banner.rhombus.brown": "Rombus Perang",
  "block.minecraft.banner.rhombus.cyan": "Rombus Sian",
  "block.minecraft.banner.rhombus.gray": "Rombus Kelabu",
  "block.minecraft.banner.rhombus.green": "Rombus Hijau",
  "block.minecraft.banner.rhombus.light_blue": "Rombus Biru Muda",
  "block.minecraft.banner.rhombus.light_gray": "Rombus Kelabu Muda",
  "block.minecraft.banner.rhombus.lime": "Rombus Hijau Muda",
  "block.minecraft.banner.rhombus.magenta": "Rombus Magenta",
  "block.minecraft.banner.rhombus.orange": "Rombus Jingga",
  "block.minecraft.banner.rhombus.pink": "Rombus Merah Jambu",
  "block.minecraft.banner.rhombus.purple": "Rombus Ungu",
  "block.minecraft.banner.rhombus.red": "Rombus Merah",
  "block.minecraft.banner.rhombus.white": "Rombus Putih",
  "block.minecraft.banner.rhombus.yellow": "Rombus Kuning",
  "block.minecraft.banner.skull.black": "Lambang Tengkorak Hitam",
  "block.minecraft.banner.skull.blue": "Lambang Tengkorak Biru",
  "block.minecraft.banner.skull.brown": "Lambang Tengkorak Perang",
  "block.minecraft.banner.skull.cyan": "Lambang Tengkorak Sian",
  "block.minecraft.banner.skull.gray": "Lambang Tengkorak Kelabu",
  "block.minecraft.banner.skull.green": "Lambang Tengkorak Hijau",
  "block.minecraft.banner.skull.light_blue": "Lambang Tengkorak Biru Muda",
  "block.minecraft.banner.skull.light_gray": "Lambang Tengkorak Kelabu Muda",
  "block.minecraft.banner.skull.lime": "Lambang Tengkorak Hijau Muda",
  "block.minecraft.banner.skull.magenta": "Lambang Tengkorak Magenta",
  "block.minecraft.banner.skull.orange": "Lambang Tengkorak Jingga",
  "block.minecraft.banner.skull.pink": "Lambang Tengkorak Merah Jambu",
  "block.minecraft.banner.skull.purple": "Lambang Tengkorak Ungu",
  "block.minecraft.banner.skull.red": "Lambang Tengkorak Merah",
  "block.minecraft.banner.skull.white": "Lambang Tengkorak Putih",
  "block.minecraft.banner.skull.yellow": "Lambang Tengkorak Kuning",
  "block.minecraft.banner.small_stripes.black": "Jejalur Hitam",
  "block.minecraft.banner.small_stripes.blue": "Jejalur Biru",
  "block.minecraft.banner.small_stripes.brown": "Jejalur Perang",
  "block.minecraft.banner.small_stripes.cyan": "Jejalur Sian",
  "block.minecraft.banner.small_stripes.gray": "Jejalur Kelabu",
  "block.minecraft.banner.small_stripes.green": "Jejalur Hijau",
  "block.minecraft.banner.small_stripes.light_blue": "Jejalur Biru Muda",
  "block.minecraft.banner.small_stripes.light_gray": "Jejalur Kelabu Muda",
  "block.minecraft.banner.small_stripes.lime": "Jejalur Hijau Muda",
  "block.minecraft.banner.small_stripes.magenta": "Jejalur Magenta",
  "block.minecraft.banner.small_stripes.orange": "Jejalur Jingga",
  "block.minecraft.banner.small_stripes.pink": "Jejalur Merah Jambu",
  "block.minecraft.banner.small_stripes.purple": "Jejalur Ungu",
  "block.minecraft.banner.small_stripes.red": "Jejalur Merah",
  "block.minecraft.banner.small_stripes.white": "Jejalur Putih",
  "block.minecraft.banner.small_stripes.yellow": "Jejalur Kuning",
  "block.minecraft.banner.square_bottom_left.black": "Kanton Kiri Bawah Hitam",
  "block.minecraft.banner.square_bottom_left.blue": "Kanton Kiri Bawah Biru",
  "block.minecraft.banner.square_bottom_left.brown": "Kanton Kiri Bawah Perang",
  "block.minecraft.banner.square_bottom_left.cyan": "Kanton Kiri Bawah Sian",
  "block.minecraft.banner.square_bottom_left.gray": "Kanton Kiri Bawah Kelabu",
  "block.minecraft.banner.square_bottom_left.green": "Kanton Kiri Bawah Hijau",
  "block.minecraft.banner.square_bottom_left.light_blue": "Kanton Kiri Bawah Biru Muda",
  "block.minecraft.banner.square_bottom_left.light_gray": "Kanton Kiri Bawah Kelabu Muda",
  "block.minecraft.banner.square_bottom_left.lime": "Kanton Kiri Bawah Hijau Muda",
  "block.minecraft.banner.square_bottom_left.magenta": "Kanton Kiri Bawah Magenta",
  "block.minecraft.banner.square_bottom_left.orange": "Kanton Kiri Bawah Jingga",
  "block.minecraft.banner.square_bottom_left.pink": "Kanton Kiri Bawah Merah Jambu",
  "block.minecraft.banner.square_bottom_left.purple": "Kanton Kiri Bawah Ungu",
  "block.minecraft.banner.square_bottom_left.red": "Kanton Kiri Bawah Merah",
  "block.minecraft.banner.square_bottom_left.white": "Kanton Kiri Bawah Putih",
  "block.minecraft.banner.square_bottom_left.yellow": "Kanton Kiri Bawah Kuning",
  "block.minecraft.banner.square_bottom_right.black": "Kanton Kanan Bawah Hitam",
  "block.minecraft.banner.square_bottom_right.blue": "Kanton Kanan Bawah Biru",
  "block.minecraft.banner.square_bottom_right.brown": "Kanton Kanan Bawah Perang",
  "block.minecraft.banner.square_bottom_right.cyan": "Kanton Kanan Bawah Sian",
  "block.minecraft.banner.square_bottom_right.gray": "Kanton Kanan Bawah Kelabu",
  "block.minecraft.banner.square_bottom_right.green": "Kanton Kanan Bawah Hijau",
  "block.minecraft.banner.square_bottom_right.light_blue": "Kanton Kanan Bawah Biru Muda",
  "block.minecraft.banner.square_bottom_right.light_gray": "Kanton Kanan Bawah Kelabu Muda",
  "block.minecraft.banner.square_bottom_right.lime": "Kanton Kanan Bawah Hijau Muda",
  "block.minecraft.banner.square_bottom_right.magenta": "Kanton Kanan Bawah Magenta",
  "block.minecraft.banner.square_bottom_right.orange": "Kanton Kanan Bawah Jingga",
  "block.minecraft.banner.square_bottom_right.pink": "Kanton Kanan Bawah Merah Jambu",
  "block.minecraft.banner.square_bottom_right.purple": "Kanton Kanan Bawah Ungu",
  "block.minecraft.banner.square_bottom_right.red": "Kanton Kanan Bawah Merah",
  "block.minecraft.banner.square_bottom_right.white": "Kanton Kanan Bawah Putih",
  "block.minecraft.banner.square_bottom_right.yellow": "Kanton Kanan Bawah Kuning",
  "block.minecraft.banner.square_top_left.black": "Kanton Kiri Atas Hitam",
  "block.minecraft.banner.square_top_left.blue": "Kanton Kiri Atas Biru",
  "block.minecraft.banner.square_top_left.brown": "Kanton Kiri Atas Perang",
  "block.minecraft.banner.square_top_left.cyan": "Kanton Kiri Atas Sian",
  "block.minecraft.banner.square_top_left.gray": "Kanton Kiri Atas Kelabu",
  "block.minecraft.banner.square_top_left.green": "Kanton Kiri Atas Hijau",
  "block.minecraft.banner.square_top_left.light_blue": "Kanton Kiri Atas Biru Muda",
  "block.minecraft.banner.square_top_left.light_gray": "Kanton Kiri Atas Kelabu Muda",
  "block.minecraft.banner.square_top_left.lime": "Kanton Kiri Atas Hijau Muda",
  "block.minecraft.banner.square_top_left.magenta": "Kanton Kiri Atas Magenta",
  "block.minecraft.banner.square_top_left.orange": "Kanton Kiri Atas Jingga",
  "block.minecraft.banner.square_top_left.pink": "Kanton Kiri Atas Merah Jambu",
  "block.minecraft.banner.square_top_left.purple": "Kanton Kiri Atas Ungu",
  "block.minecraft.banner.square_top_left.red": "Kanton Kiri Atas Merah",
  "block.minecraft.banner.square_top_left.white": "Kanton Kiri Atas Putih",
  "block.minecraft.banner.square_top_left.yellow": "Kanton Kiri Atas Kuning",
  "block.minecraft.banner.square_top_right.black": "Kanton Kanan Atas Hitam",
  "block.minecraft.banner.square_top_right.blue": "Kanton Kanan Atas Biru",
  "block.minecraft.banner.square_top_right.brown": "Kanton Kanan Atas Perang",
  "block.minecraft.banner.square_top_right.cyan": "Kanton Kanan Atas Sian",
  "block.minecraft.banner.square_top_right.gray": "Kanton Kanan Atas Kelabu",
  "block.minecraft.banner.square_top_right.green": "Kanton Kanan Atas Hijau",
  "block.minecraft.banner.square_top_right.light_blue": "Kanton Kanan Atas Biru Muda",
  "block.minecraft.banner.square_top_right.light_gray": "Kanton Kanan Atas Kelabu Muda",
  "block.minecraft.banner.square_top_right.lime": "Kanton Kanan Atas Hijau Muda",
  "block.minecraft.banner.square_top_right.magenta": "Kanton Kanan Atas Magenta",
  "block.minecraft.banner.square_top_right.orange": "Kanton Kanan Atas Jingga",
  "block.minecraft.banner.square_top_right.pink": "Kanton Kanan Atas Merah Jambu",
  "block.minecraft.banner.square_top_right.purple": "Kanton Kanan Atas Ungu",
  "block.minecraft.banner.square_top_right.red": "Kanton Kanan Atas Merah",
  "block.minecraft.banner.square_top_right.white": "Kanton Kanan Atas Putih",
  "block.minecraft.banner.square_top_right.yellow": "Kanton Kanan Atas Kuning",
  "block.minecraft.banner.straight_cross.black": "Palang Hitam",
  "block.minecraft.banner.straight_cross.blue": "Palang Biru",
  "block.minecraft.banner.straight_cross.brown": "Palang Perang",
  "block.minecraft.banner.straight_cross.cyan": "Palang Sian",
  "block.minecraft.banner.straight_cross.gray": "Palang Kelabu",
  "block.minecraft.banner.straight_cross.green": "Palang Hijau",
  "block.minecraft.banner.straight_cross.light_blue": "Palang Biru Muda",
  "block.minecraft.banner.straight_cross.light_gray": "Palang Kelabu Muda",
  "block.minecraft.banner.straight_cross.lime": "Palang Hijau Muda",
  "block.minecraft.banner.straight_cross.magenta": "Palang Magenta",
  "block.minecraft.banner.straight_cross.orange": "Palang Jingga",
  "block.minecraft.banner.straight_cross.pink": "Palang Merah Jambu",
  "block.minecraft.banner.straight_cross.purple": "Palang Ungu",
  "block.minecraft.banner.straight_cross.red": "Palang Merah",
  "block.minecraft.banner.straight_cross.white": "Palang Putih",
  "block.minecraft.banner.straight_cross.yellow": "Palang Kuning",
  "block.minecraft.banner.stripe_bottom.black": "Pengaki Hitam",
  "block.minecraft.banner.stripe_bottom.blue": "Pengaki Biru",
  "block.minecraft.banner.stripe_bottom.brown": "Pengaki Perang",
  "block.minecraft.banner.stripe_bottom.cyan": "Pengaki Sian",
  "block.minecraft.banner.stripe_bottom.gray": "Pengaki Kelabu",
  "block.minecraft.banner.stripe_bottom.green": "Pengaki Hijau",
  "block.minecraft.banner.stripe_bottom.light_blue": "Pengaki Biru Muda",
  "block.minecraft.banner.stripe_bottom.light_gray": "Pengaki Kelabu Muda",
  "block.minecraft.banner.stripe_bottom.lime": "Pengaki Hijau Muda",
  "block.minecraft.banner.stripe_bottom.magenta": "Pengaki Magenta",
  "block.minecraft.banner.stripe_bottom.orange": "Pengaki Jingga",
  "block.minecraft.banner.stripe_bottom.pink": "Pengaki Merah Jambu",
  "block.minecraft.banner.stripe_bottom.purple": "Pengaki Ungu",
  "block.minecraft.banner.stripe_bottom.red": "Pengaki Merah",
  "block.minecraft.banner.stripe_bottom.white": "Pengaki Putih",
  "block.minecraft.banner.stripe_bottom.yellow": "Pengaki Kuning",
  "block.minecraft.banner.stripe_center.black": "Jalur Mencancang Hitam",
  "block.minecraft.banner.stripe_center.blue": "Jalur Mencancang Biru",
  "block.minecraft.banner.stripe_center.brown": "Jalur Mencancang Perang",
  "block.minecraft.banner.stripe_center.cyan": "Jalur Mencancang Sian",
  "block.minecraft.banner.stripe_center.gray": "Jalur Mencancang Kelabu",
  "block.minecraft.banner.stripe_center.green": "Jalur Mencancang Hijau",
  "block.minecraft.banner.stripe_center.light_blue": "Jalur Mencancang Biru Muda",
  "block.minecraft.banner.stripe_center.light_gray": "Jalur Mencancang Kelabu Muda",
  "block.minecraft.banner.stripe_center.lime": "Jalur Mencancang Hijau Muda",
  "block.minecraft.banner.stripe_center.magenta": "Jalur Mencancang Magenta",
  "block.minecraft.banner.stripe_center.orange": "Jalur Mencancang Jingga",
  "block.minecraft.banner.stripe_center.pink": "Jalur Mencancang Merah Jambu",
  "block.minecraft.banner.stripe_center.purple": "Jejalur Ungu",
  "block.minecraft.banner.stripe_center.red": "Jalur Mencancang Merah",
  "block.minecraft.banner.stripe_center.white": "Jalur Mencancang Putih",
  "block.minecraft.banner.stripe_center.yellow": "Jalur Mencancang Kuning",
  "block.minecraft.banner.stripe_downleft.black": "Jalur Serong Kiri Hitam",
  "block.minecraft.banner.stripe_downleft.blue": "Jalur Serong Kiri Biru",
  "block.minecraft.banner.stripe_downleft.brown": "Jalur Serong Kiri Perang",
  "block.minecraft.banner.stripe_downleft.cyan": "Jalur Serong Kiri Sian",
  "block.minecraft.banner.stripe_downleft.gray": "Jalur Serong Kiri Kelabu",
  "block.minecraft.banner.stripe_downleft.green": "Jalur Serong Kiri Hijau",
  "block.minecraft.banner.stripe_downleft.light_blue": "Jalur Serong Kiri Biru Muda",
  "block.minecraft.banner.stripe_downleft.light_gray": "Jalur Serong Kiri Kelabu Muda",
  "block.minecraft.banner.stripe_downleft.lime": "Jalur Serong Kiri Hijau Muda",
  "block.minecraft.banner.stripe_downleft.magenta": "Jalur Serong Kiri Magenta",
  "block.minecraft.banner.stripe_downleft.orange": "Jalur Serong Kiri Jingga",
  "block.minecraft.banner.stripe_downleft.pink": "Jalur Serong Kiri Merah Jambu",
  "block.minecraft.banner.stripe_downleft.purple": "Jalur Serong Kiri Ungu",
  "block.minecraft.banner.stripe_downleft.red": "Jalur Serong Kiri Merah",
  "block.minecraft.banner.stripe_downleft.white": "Jalur Serong Kiri Putih",
  "block.minecraft.banner.stripe_downleft.yellow": "Jalur Serong Kiri Kuning",
  "block.minecraft.banner.stripe_downright.black": "Jalur Serong Hitam",
  "block.minecraft.banner.stripe_downright.blue": "Jalur Serong Biru",
  "block.minecraft.banner.stripe_downright.brown": "Jalur Serong Perang",
  "block.minecraft.banner.stripe_downright.cyan": "Jalur Serong Sian",
  "block.minecraft.banner.stripe_downright.gray": "Jalur Serong Kelabu",
  "block.minecraft.banner.stripe_downright.green": "Jalur Serong Hijau",
  "block.minecraft.banner.stripe_downright.light_blue": "Jalur Serong Biru Muda",
  "block.minecraft.banner.stripe_downright.light_gray": "Jalur Serong Kelabu Muda",
  "block.minecraft.banner.stripe_downright.lime": "Jalur Serong Hijau Muda",
  "block.minecraft.banner.stripe_downright.magenta": "Jalur Serong Magenta",
  "block.minecraft.banner.stripe_downright.orange": "Jalur Serong Jingga",
  "block.minecraft.banner.stripe_downright.pink": "Jalur Serong Merah Jambu",
  "block.minecraft.banner.stripe_downright.purple": "Jalur Serong Ungu",
  "block.minecraft.banner.stripe_downright.red": "Jalur Serong Merah",
  "block.minecraft.banner.stripe_downright.white": "Jalur Serong Putih",
  "block.minecraft.banner.stripe_downright.yellow": "Jalur Serong Kuning",
  "block.minecraft.banner.stripe_left.black": "Jalur Mencancang Kiri Hitam",
  "block.minecraft.banner.stripe_left.blue": "Jalur Mencancang Kiri Biru",
  "block.minecraft.banner.stripe_left.brown": "Jalur Mencancang Kiri Perang",
  "block.minecraft.banner.stripe_left.cyan": "Jalur Mencancang Kiri Sian",
  "block.minecraft.banner.stripe_left.gray": "Jalur Mencancang Kiri Kelabu",
  "block.minecraft.banner.stripe_left.green": "Jalur Mencancang Kiri Hijau",
  "block.minecraft.banner.stripe_left.light_blue": "Jalur Mencancang Kiri Biru Muda",
  "block.minecraft.banner.stripe_left.light_gray": "Jalur Mencancang Kiri Kelabu Muda",
  "block.minecraft.banner.stripe_left.lime": "Jalur Mencancang Kiri Hijau Muda",
  "block.minecraft.banner.stripe_left.magenta": "Jalur Mencancang Kiri Magenta",
  "block.minecraft.banner.stripe_left.orange": "Jalur Mencancang Kiri Jingga",
  "block.minecraft.banner.stripe_left.pink": "Jalur Mencancang Kiri Merah Jambu",
  "block.minecraft.banner.stripe_left.purple": "Jalur Mencancang Kiri Ungu",
  "block.minecraft.banner.stripe_left.red": "Jalur Mencancang Kiri Merah",
  "block.minecraft.banner.stripe_left.white": "Jalur Mencancang Kiri Putih",
  "block.minecraft.banner.stripe_left.yellow": "Jalur Mencancang Kiri Kuning",
  "block.minecraft.banner.stripe_middle.black": "Jalur Mengufuk Hitam",
  "block.minecraft.banner.stripe_middle.blue": "Jalur Mengufuk Biru",
  "block.minecraft.banner.stripe_middle.brown": "Jalur Mengufuk Perang",
  "block.minecraft.banner.stripe_middle.cyan": "Jalur Mengufuk Sian",
  "block.minecraft.banner.stripe_middle.gray": "Jalur Mengufuk Kelabu",
  "block.minecraft.banner.stripe_middle.green": "Jalur Mengufuk Hijau",
  "block.minecraft.banner.stripe_middle.light_blue": "Jalur Mengufuk Biru Muda",
  "block.minecraft.banner.stripe_middle.light_gray": "Jalur Mengufuk Kelabu Muda",
  "block.minecraft.banner.stripe_middle.lime": "Jalur Mengufuk Hijau Muda",
  "block.minecraft.banner.stripe_middle.magenta": "Jalur Mengufuk Magenta",
  "block.minecraft.banner.stripe_middle.orange": "Jalur Mengufuk Jingga",
  "block.minecraft.banner.stripe_middle.pink": "Jalur Mengufuk Merah Jambu",
  "block.minecraft.banner.stripe_middle.purple": "Jalur Mengufuk Ungu",
  "block.minecraft.banner.stripe_middle.red": "Jalur Mengufuk Merah",
  "block.minecraft.banner.stripe_middle.white": "Jalur Mengufuk Putih",
  "block.minecraft.banner.stripe_middle.yellow": "Jalur Mengufuk Kuning",
  "block.minecraft.banner.stripe_right.black": "Jalur Mencancang Kanan Hitam",
  "block.minecraft.banner.stripe_right.blue": "Jalur Mencancang Kanan Biru",
  "block.minecraft.banner.stripe_right.brown": "Jalur Mencancang Kanan Perang",
  "block.minecraft.banner.stripe_right.cyan": "Jalur Mencancang Kanan Sian",
  "block.minecraft.banner.stripe_right.gray": "Jalur Mencancang Kanan Kelabu",
  "block.minecraft.banner.stripe_right.green": "Jalur Mencancang Kanan Hijau",
  "block.minecraft.banner.stripe_right.light_blue": "Jalur Mencancang Kanan Biru Muda",
  "block.minecraft.banner.stripe_right.light_gray": "Jalur Mencancang Kanan Kelabu Muda",
  "block.minecraft.banner.stripe_right.lime": "Jalur Mencancang Kanan Hijau Muda",
  "block.minecraft.banner.stripe_right.magenta": "Jalur Mencancang Kanan Magenta",
  "block.minecraft.banner.stripe_right.orange": "Jalur Mencancang Kanan Jingga",
  "block.minecraft.banner.stripe_right.pink": "Jalur Mencancang Kanan Merah Jambu",
  "block.minecraft.banner.stripe_right.purple": "Jalur Mencancang Kanan Ungu",
  "block.minecraft.banner.stripe_right.red": "Jalur Mencancang Kanan Merah",
  "block.minecraft.banner.stripe_right.white": "Jalur Mencancang Kanan Putih",
  "block.minecraft.banner.stripe_right.yellow": "Jalur Mencancang Kanan Kuning",
  "block.minecraft.banner.stripe_top.black": "Pengepala Hitam",
  "block.minecraft.banner.stripe_top.blue": "Pengepala Biru",
  "block.minecraft.banner.stripe_top.brown": "Pengepala Perang",
  "block.minecraft.banner.stripe_top.cyan": "Pengepala Sian",
  "block.minecraft.banner.stripe_top.gray": "Pengepala Kelabu",
  "block.minecraft.banner.stripe_top.green": "Pengepala Hijau",
  "block.minecraft.banner.stripe_top.light_blue": "Pengepala Biru Muda",
  "block.minecraft.banner.stripe_top.light_gray": "Pengepala Kelabu Muda",
  "block.minecraft.banner.stripe_top.lime": "Pengepala Hijau Muda",
  "block.minecraft.banner.stripe_top.magenta": "Pengepala Magenta",
  "block.minecraft.banner.stripe_top.orange": "Pengepala Jingga",
  "block.minecraft.banner.stripe_top.pink": "Pengepala Merah Jambu",
  "block.minecraft.banner.stripe_top.purple": "Pengepala Ungu",
  "block.minecraft.banner.stripe_top.red": "Pengepala Merah",
  "block.minecraft.banner.stripe_top.white": "Pengepala Putih",
  "block.minecraft.banner.stripe_top.yellow": "Pengepala Kuning",
  "block.minecraft.banner.triangle_bottom.black": "Sevron Hitam",
  "block.minecraft.banner.triangle_bottom.blue": "Sevron Biru",
  "block.minecraft.banner.triangle_bottom.brown": "Sevron Perang",
  "block.minecraft.banner.triangle_bottom.cyan": "Sevron Sian",
  "block.minecraft.banner.triangle_bottom.gray": "Sevron Kelabu",
  "block.minecraft.banner.triangle_bottom.green": "Sevron Hijau",
  "block.minecraft.banner.triangle_bottom.light_blue": "Sevron Biru Muda",
  "block.minecraft.banner.triangle_bottom.light_gray": "Sevron Kelabu Muda",
  "block.minecraft.banner.triangle_bottom.lime": "Sevron Hijau Muda",
  "block.minecraft.banner.triangle_bottom.magenta": "Sevron Magenta",
  "block.minecraft.banner.triangle_bottom.orange": "Sevron Jingga",
  "block.minecraft.banner.triangle_bottom.pink": "Sevron Merah Jambu",
  "block.minecraft.banner.triangle_bottom.purple": "Sevron Ungu",
  "block.minecraft.banner.triangle_bottom.red": "Sevron Merah",
  "block.minecraft.banner.triangle_bottom.white": "Sevron Putih",
  "block.minecraft.banner.triangle_bottom.yellow": "Sevron Kuning",
  "block.minecraft.banner.triangle_top.black": "Sevron Songsang Hitam",
  "block.minecraft.banner.triangle_top.blue": "Sevron Songsang Biru",
  "block.minecraft.banner.triangle_top.brown": "Sevron Songsang Perang",
  "block.minecraft.banner.triangle_top.cyan": "Sevron Songsang Sian",
  "block.minecraft.banner.triangle_top.gray": "Sevron Songsang Kelabu",
  "block.minecraft.banner.triangle_top.green": "Sevron Songsang Hijau",
  "block.minecraft.banner.triangle_top.light_blue": "Sevron Songsang Biru Muda",
  "block.minecraft.banner.triangle_top.light_gray": "Sevron Songsang Kelabu Muda",
  "block.minecraft.banner.triangle_top.lime": "Sevron Songsang Hijau Muda",
  "block.minecraft.banner.triangle_top.magenta": "Sevron Songsang Magenta",
  "block.minecraft.banner.triangle_top.orange": "Sevron Songsang Jingga",
  "block.minecraft.banner.triangle_top.pink": "Sevron Songsang Merah Jambu",
  "block.minecraft.banner.triangle_top.purple": "Sevron Songsang Ungu",
  "block.minecraft.banner.triangle_top.red": "Sevron Songsang Merah",
  "block.minecraft.banner.triangle_top.white": "Sevron Songsang Putih",
  "block.minecraft.banner.triangle_top.yellow": "Sevron Songsang Kuning",
  "block.minecraft.banner.triangles_bottom.black": "Pengaki Bergerigi Hitam",
  "block.minecraft.banner.triangles_bottom.blue": "Pengaki Bergerigi Biru",
  "block.minecraft.banner.triangles_bottom.brown": "Pengaki Bergerigi Perang",
  "block.minecraft.banner.triangles_bottom.cyan": "Pengaki Bergerigi Sian",
  "block.minecraft.banner.triangles_bottom.gray": "Pengaki Bergerigi Kelabu",
  "block.minecraft.banner.triangles_bottom.green": "Pengaki Bergerigi Hijau",
  "block.minecraft.banner.triangles_bottom.light_blue": "Pengaki Bergerigi Biru Muda",
  "block.minecraft.banner.triangles_bottom.light_gray": "Pengaki Bergerigi Kelabu Muda",
  "block.minecraft.banner.triangles_bottom.lime": "Pengaki Bergerigi Hijau Muda",
  "block.minecraft.banner.triangles_bottom.magenta": "Pengaki Bergerigi Magenta",
  "block.minecraft.banner.triangles_bottom.orange": "Pengaki Bergerigi Jingga",
  "block.minecraft.banner.triangles_bottom.pink": "Pengaki Bergerigi Merah Jambu",
  "block.minecraft.banner.triangles_bottom.purple": "Pengaki Bergerigi Ungu",
  "block.minecraft.banner.triangles_bottom.red": "Pengaki Bergerigi Merah",
  "block.minecraft.banner.triangles_bottom.white": "Pengaki Bergerigi Putih",
  "block.minecraft.banner.triangles_bottom.yellow": "Pengaki Bergerigi Kuning",
  "block.minecraft.banner.triangles_top.black": "Pengepala Bergerigi Hitam",
  "block.minecraft.banner.triangles_top.blue": "Pengepala Bergerigi Biru",
  "block.minecraft.banner.triangles_top.brown": "Pengepala Bergerigi Perang",
  "block.minecraft.banner.triangles_top.cyan": "Pengepala Bergerigi Sian",
  "block.minecraft.banner.triangles_top.gray": "Pengepala Bergerigi Kelabu",
  "block.minecraft.banner.triangles_top.green": "Pengepala Bergerigi Hijau",
  "block.minecraft.banner.triangles_top.light_blue": "Pengepala Bergerigi Biru Muda",
  "block.minecraft.banner.triangles_top.light_gray": "Pengepala Bergerigi Kelabu Muda",
  "block.minecraft.banner.triangles_top.lime": "Pengepala Bergerigi Hijau Muda",
  "block.minecraft.banner.triangles_top.magenta": "Pengepala Bergerigi Magenta",
  "block.minecraft.banner.triangles_top.orange": "Pengepala Bergerigi Jingga",
  "block.minecraft.banner.triangles_top.pink": "Pengepala Bergerigi Merah Jambu",
  "block.minecraft.banner.triangles_top.purple": "Pengepala Bergerigi Ungu",
  "block.minecraft.banner.triangles_top.red": "Pengepala Bergerigi Merah",
  "block.minecraft.banner.triangles_top.white": "Pengepala Bergerigi Putih",
  "block.minecraft.banner.triangles_top.yellow": "Pengepala Bergerigi Kuning",
  "block.minecraft.barrel": "Tahang",
  "block.minecraft.barrier": "Halangan",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Suar",
  "block.minecraft.beacon.primary": "Kuasa Utama",
  "block.minecraft.beacon.secondary": "Kuasa Menengah",
  "block.minecraft.bed.no_sleep": "Anda hanya boleh tidur pada waktu malam atau semasa ribut petir",
  "block.minecraft.bed.not_safe": "Anda tidak boleh berehat sekarang; terdapat raksasa berhampiran",
  "block.minecraft.bed.obstructed": "Katil ini tersekat",
  "block.minecraft.bed.occupied": "Katil ini telah diduduki",
  "block.minecraft.bed.too_far_away": "Anda tidak boleh berehat sekarang; katil anda terlalu jauh",
  "block.minecraft.bedrock": "Batu Dasar",
  "block.minecraft.bee_nest": "Sarang Lebah",
  "block.minecraft.beehive": "Sarang Lebah Buatan",
  "block.minecraft.beetroots": "Ubi Bit",
  "block.minecraft.bell": "Genta",
  "block.minecraft.big_dripleaf": "Daun Titis Besar",
  "block.minecraft.big_dripleaf_stem": "Batang Daun Titis Besar",
  "block.minecraft.birch_button": "Butang Birch",
  "block.minecraft.birch_door": "Pintu Kayu Birch",
  "block.minecraft.birch_fence": "Pagar Birch",
  "block.minecraft.birch_fence_gate": "Pintu Pagar Birch",
  "block.minecraft.birch_hanging_sign": "Papan Tanda Bergantung Birch",
  "block.minecraft.birch_leaves": "Daun Birch",
  "block.minecraft.birch_log": "Kayu Balak Birch",
  "block.minecraft.birch_planks": "Papan Kayu Birch",
  "block.minecraft.birch_pressure_plate": "Plat Tekanan Birch",
  "block.minecraft.birch_sapling": "Anak Pokok Birch",
  "block.minecraft.birch_shelf": "Rak Birch",
  "block.minecraft.birch_sign": "Papan Tanda Birch",
  "block.minecraft.birch_slab": "Papak Birch",
  "block.minecraft.birch_stairs": "Tangga Birch",
  "block.minecraft.birch_trapdoor": "Pintu Kolong Birch",
  "block.minecraft.birch_wall_hanging_sign": "Papan Tanda Bergantung Dinding Birch",
  "block.minecraft.birch_wall_sign": "Papan Tanda Dinding Birch",
  "block.minecraft.birch_wood": "Kayu Birch",
  "block.minecraft.black_banner": "Panji Hitam",
  "block.minecraft.black_bed": "Katil Hitam",
  "block.minecraft.black_candle": "Dian Hitam",
  "block.minecraft.black_candle_cake": "Kek Berdian Hitam",
  "block.minecraft.black_carpet": "Permaidani Hitam",
  "block.minecraft.black_concrete": "Konkrit Hitam",
  "block.minecraft.black_concrete_powder": "Serbuk Konkrit Hitam",
  "block.minecraft.black_glazed_terracotta": "Terakota Licau Hitam",
  "block.minecraft.black_shulker_box": "Kotak Shulker Hitam",
  "block.minecraft.black_stained_glass": "Kaca Berwarna Hitam",
  "block.minecraft.black_stained_glass_pane": "Anak Kaca Berwarna Hitam",
  "block.minecraft.black_terracotta": "Terakota Hitam",
  "block.minecraft.black_wool": "Bulu Hitam",
  "block.minecraft.blackstone": "Batu Hitam",
  "block.minecraft.blackstone_slab": "Papak Batu Hitam",
  "block.minecraft.blackstone_stairs": "Tangga Batu Hitam",
  "block.minecraft.blackstone_wall": "Tembok Batu Hitam",
  "block.minecraft.blast_furnace": "Relau Bagas",
  "block.minecraft.blue_banner": "Panji Biru",
  "block.minecraft.blue_bed": "Katil Biru",
  "block.minecraft.blue_candle": "Dian Biru",
  "block.minecraft.blue_candle_cake": "Kek Berdian Biru",
  "block.minecraft.blue_carpet": "Permaidani Biru",
  "block.minecraft.blue_concrete": "Konkrit Biru",
  "block.minecraft.blue_concrete_powder": "Serbuk Konkrit Biru",
  "block.minecraft.blue_glazed_terracotta": "Terakota Licau Biru",
  "block.minecraft.blue_ice": "Ais Biru",
  "block.minecraft.blue_orchid": "Orkid Biru",
  "block.minecraft.blue_shulker_box": "Kotak Shulker Biru",
  "block.minecraft.blue_stained_glass": "Kaca Berwarna Biru",
  "block.minecraft.blue_stained_glass_pane": "Anak Kaca Berwarna Biru",
  "block.minecraft.blue_terracotta": "Terakota Biru",
  "block.minecraft.blue_wool": "Bulu Biru",
  "block.minecraft.bone_block": "Blok Tulang",
  "block.minecraft.bookshelf": "Rak Buku",
  "block.minecraft.brain_coral": "Karang Otak",
  "block.minecraft.brain_coral_block": "Blok Karang Otak",
  "block.minecraft.brain_coral_fan": "Akar Bahar Otak",
  "block.minecraft.brain_coral_wall_fan": "Akar Bahar Dinding Otak",
  "block.minecraft.brewing_stand": "Tapak Membru",
  "block.minecraft.brick_slab": "Papak Bata",
  "block.minecraft.brick_stairs": "Tangga Bata",
  "block.minecraft.brick_wall": "Tembok Bata",
  "block.minecraft.bricks": "Bata",
  "block.minecraft.brown_banner": "Panji Perang",
  "block.minecraft.brown_bed": "Katil Perang",
  "block.minecraft.brown_candle": "Dian Perang",
  "block.minecraft.brown_candle_cake": "Kek Berdian Perang",
  "block.minecraft.brown_carpet": "Permaidani Perang",
  "block.minecraft.brown_concrete": "Konkrit Perang",
  "block.minecraft.brown_concrete_powder": "Serbuk Konkrit Perang",
  "block.minecraft.brown_glazed_terracotta": "Terakota Licau Perang",
  "block.minecraft.brown_mushroom": "Cendawan Perang",
  "block.minecraft.brown_mushroom_block": "Blok Cendawan Perang",
  "block.minecraft.brown_shulker_box": "Kotak Shulker Perang",
  "block.minecraft.brown_stained_glass": "Kaca Berwarna Perang",
  "block.minecraft.brown_stained_glass_pane": "Anak Kaca Berwarna Perang",
  "block.minecraft.brown_terracotta": "Terakota Perang",
  "block.minecraft.brown_wool": "Bulu Perang",
  "block.minecraft.bubble_column": "Kepulan Buih",
  "block.minecraft.bubble_coral": "Karang Buih",
  "block.minecraft.bubble_coral_block": "Blok Karang Buih",
  "block.minecraft.bubble_coral_fan": "Akar Bahar Buih",
  "block.minecraft.bubble_coral_wall_fan": "Akar Bahar Dinding Buih",
  "block.minecraft.budding_amethyst": "Batu Kecubung Menunas",
  "block.minecraft.bush": "Semak",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Bunga Kaktus",
  "block.minecraft.cake": "Kek",
  "block.minecraft.calcite": "Kalsit",
  "block.minecraft.calibrated_sculk_sensor": "Penderia Sculk Tertentukur",
  "block.minecraft.campfire": "Unggun Api",
  "block.minecraft.candle": "Dian",
  "block.minecraft.candle_cake": "Kek Berdian",
  "block.minecraft.carrots": "Lobak",
  "block.minecraft.cartography_table": "Pertukangan Peta",
  "block.minecraft.carved_pumpkin": "Labu Diukir",
  "block.minecraft.cauldron": "Kawah",
  "block.minecraft.cave_air": "Udara Gua",
  "block.minecraft.cave_vines": "Penjalar Gua",
  "block.minecraft.cave_vines_plant": "Pokok Penjalar Gua",
  "block.minecraft.chain": "Rantai",
  "block.minecraft.chain_command_block": "Blok Perintah Berantai",
  "block.minecraft.cherry_button": "Butang Sakura",
  "block.minecraft.cherry_door": "Pintu Sakura",
  "block.minecraft.cherry_fence": "Pagar Sakura",
  "block.minecraft.cherry_fence_gate": "Pintu Pagar Sakura",
  "block.minecraft.cherry_hanging_sign": "Papan Tanda Bergantung Sakura",
  "block.minecraft.cherry_leaves": "Daun Sakura",
  "block.minecraft.cherry_log": "Kayu Balak Sakura",
  "block.minecraft.cherry_planks": "Papan Sakura",
  "block.minecraft.cherry_pressure_plate": "Plat Tekanan Sakura",
  "block.minecraft.cherry_sapling": "Anak Pokok Sakura",
  "block.minecraft.cherry_shelf": "Rak Sakura",
  "block.minecraft.cherry_sign": "Papan Tanda Sakura",
  "block.minecraft.cherry_slab": "Papak Sakura",
  "block.minecraft.cherry_stairs": "Tangga Sakura",
  "block.minecraft.cherry_trapdoor": "Pintu Kolong Sakura",
  "block.minecraft.cherry_wall_hanging_sign": "Papan Tanda Bergantung Dinding Sakura",
  "block.minecraft.cherry_wall_sign": "Papan Tanda Dinding Sakura",
  "block.minecraft.cherry_wood": "Kayu Sakura",
  "block.minecraft.chest": "Peti",
  "block.minecraft.chipped_anvil": "Andas Sumbing",
  "block.minecraft.chiseled_bookshelf": "Rak Buku Terpahat",
  "block.minecraft.chiseled_copper": "Tembaga Terpahat",
  "block.minecraft.chiseled_deepslate": "Batu Loh Terpahat",
  "block.minecraft.chiseled_nether_bricks": "Bata Nether Berukir",
  "block.minecraft.chiseled_polished_blackstone": "Batu Hitam Digilap Terpahat",
  "block.minecraft.chiseled_quartz_block": "Blok Kuarza Dipahat",
  "block.minecraft.chiseled_red_sandstone": "Batu Pasir Merah Terpahat",
  "block.minecraft.chiseled_resin_bricks": "Bata Damar Terpahat",
  "block.minecraft.chiseled_sandstone": "Batu Pasir Terpahat",
  "block.minecraft.chiseled_stone_bricks": "Bata Batu Terpahat",
  "block.minecraft.chiseled_tuff": "Tuf Terpahat",
  "block.minecraft.chiseled_tuff_bricks": "Bata Tuf Terpahat",
  "block.minecraft.chorus_flower": "Bunga Korus",
  "block.minecraft.chorus_plant": "Pokok Korus",
  "block.minecraft.clay": "Tanah Liat",
  "block.minecraft.closed_eyeblossom": "Puspa Mata Tertutup",
  "block.minecraft.coal_block": "Blok Arang Batu",
  "block.minecraft.coal_ore": "Bijih Arang Batu",
  "block.minecraft.coarse_dirt": "Tanah Kasar",
  "block.minecraft.cobbled_deepslate": "Batu Buntar Loh",
  "block.minecraft.cobbled_deepslate_slab": "Papak Batu Buntar Loh",
  "block.minecraft.cobbled_deepslate_stairs": "Tangga Batu Buntar Loh",
  "block.minecraft.cobbled_deepslate_wall": "Tembok Batu Buntar Loh",
  "block.minecraft.cobblestone": "Batu Buntar",
  "block.minecraft.cobblestone_slab": "Papak Batu Buntar",
  "block.minecraft.cobblestone_stairs": "Tangga Batu Buntar",
  "block.minecraft.cobblestone_wall": "Tembok Batu Buntar",
  "block.minecraft.cobweb": "Sarang Labah-labah",
  "block.minecraft.cocoa": "Koko",
  "block.minecraft.command_block": "Blok Perintah",
  "block.minecraft.comparator": "Pembanding Redstone",
  "block.minecraft.composter": "Pembuat Kompos",
  "block.minecraft.conduit": "Pembuluh",
  "block.minecraft.copper_bars": "Palang Tembaga",
  "block.minecraft.copper_block": "Blok Tembaga",
  "block.minecraft.copper_bulb": "Mentol Tembaga",
  "block.minecraft.copper_chain": "Rantai Tembaga",
  "block.minecraft.copper_chest": "Peti Tembaga",
  "block.minecraft.copper_door": "Pintu Tembaga",
  "block.minecraft.copper_golem_statue": "Patung Golem Tembaga",
  "block.minecraft.copper_grate": "Jeriji Tembaga",
  "block.minecraft.copper_lantern": "Tanglung Tembaga",
  "block.minecraft.copper_ore": "Bijih Tembaga",
  "block.minecraft.copper_torch": "Obor Tembaga",
  "block.minecraft.copper_trapdoor": "Pintu Kolong Tembaga",
  "block.minecraft.copper_wall_torch": "Obor Dinding Tembaga",
  "block.minecraft.cornflower": "Cornflower",
  "block.minecraft.cracked_deepslate_bricks": "Bata Loh Rekah",
  "block.minecraft.cracked_deepslate_tiles": "Genting Loh Rekah",
  "block.minecraft.cracked_nether_bricks": "Bata Nether Rekah",
  "block.minecraft.cracked_polished_blackstone_bricks": "Bata Batu Hitam Digilap Rekah",
  "block.minecraft.cracked_stone_bricks": "Bata Batu Rekah",
  "block.minecraft.crafter": "Penukang",
  "block.minecraft.crafting_table": "Pertukangan",
  "block.minecraft.creaking_heart": "Jantung Deritan",
  "block.minecraft.creeper_head": "Kepala Creeper",
  "block.minecraft.creeper_wall_head": "Kepala Dinding Creeper",
  "block.minecraft.crimson_button": "Butang Kirmizi",
  "block.minecraft.crimson_door": "Pintu Kirmizi",
  "block.minecraft.crimson_fence": "Pagar Kirmizi",
  "block.minecraft.crimson_fence_gate": "Pintu Pagar Kirmizi",
  "block.minecraft.crimson_fungus": "Kulat Kirmizi",
  "block.minecraft.crimson_hanging_sign": "Papan Tanda Bergantung Kirmizi",
  "block.minecraft.crimson_hyphae": "Hifa Kirmizi",
  "block.minecraft.crimson_nylium": "Nilium Kirmizi",
  "block.minecraft.crimson_planks": "Papan Kirmizi",
  "block.minecraft.crimson_pressure_plate": "Plat Tekanan Kirmizi",
  "block.minecraft.crimson_roots": "Akar Kirmizi",
  "block.minecraft.crimson_shelf": "Rak Kirmizi",
  "block.minecraft.crimson_sign": "Papan Tanda Kirmizi",
  "block.minecraft.crimson_slab": "Papak Kirmizi",
  "block.minecraft.crimson_stairs": "Tangga Kirmizi",
  "block.minecraft.crimson_stem": "Batang Kirmizi",
  "block.minecraft.crimson_trapdoor": "Pintu Kolong Kirmizi",
  "block.minecraft.crimson_wall_hanging_sign": "Papan Tanda Bergantung Dinding Kirmizi",
  "block.minecraft.crimson_wall_sign": "Papan Tanda Dinding Kirmizi",
  "block.minecraft.crying_obsidian": "Obsidian Menangis",
  "block.minecraft.cut_copper": "Tembaga Terpotong",
  "block.minecraft.cut_copper_slab": "Papak Tembaga Terpotong",
  "block.minecraft.cut_copper_stairs": "Tangga Tembaga Terpotong",
  "block.minecraft.cut_red_sandstone": "Batu Pasir Merah Dipotong",
  "block.minecraft.cut_red_sandstone_slab": "Papak Batu Pasir Merah Dipotong",
  "block.minecraft.cut_sandstone": "Batu Pasir Dipotong",
  "block.minecraft.cut_sandstone_slab": "Papak Batu Pasir Dipotong",
  "block.minecraft.cyan_banner": "Panji Sian",
  "block.minecraft.cyan_bed": "Katil Sian",
  "block.minecraft.cyan_candle": "Dian Sian",
  "block.minecraft.cyan_candle_cake": "Kek Berdian Sian",
  "block.minecraft.cyan_carpet": "Permaidani Sian",
  "block.minecraft.cyan_concrete": "Konkrit Sian",
  "block.minecraft.cyan_concrete_powder": "Serbuk Konkrit Sian",
  "block.minecraft.cyan_glazed_terracotta": "Terakota Licau Sian",
  "block.minecraft.cyan_shulker_box": "Kotak Shulker Sian",
  "block.minecraft.cyan_stained_glass": "Kaca Berwarna Sian",
  "block.minecraft.cyan_stained_glass_pane": "Anak Kaca Berwarna Sian",
  "block.minecraft.cyan_terracotta": "Terakota Sian",
  "block.minecraft.cyan_wool": "Bulu Sian",
  "block.minecraft.damaged_anvil": "Andas Rosak",
  "block.minecraft.dandelion": "Bunga Paliman",
  "block.minecraft.dark_oak_button": "Butang Oak Gelap",
  "block.minecraft.dark_oak_door": "Pintu Kayu Oak Gelap",
  "block.minecraft.dark_oak_fence": "Pagar Oak Gelap",
  "block.minecraft.dark_oak_fence_gate": "Pintu Pagar Oak Gelap",
  "block.minecraft.dark_oak_hanging_sign": "Papan Tanda Bergantung Oak Gelap",
  "block.minecraft.dark_oak_leaves": "Daun Oak Gelap",
  "block.minecraft.dark_oak_log": "Kayu Balak Oak Gelap",
  "block.minecraft.dark_oak_planks": "Papan Kayu Oak Gelap",
  "block.minecraft.dark_oak_pressure_plate": "Plat Tekanan Oak Gelap",
  "block.minecraft.dark_oak_sapling": "Anak Pokok Oak Gelap",
  "block.minecraft.dark_oak_shelf": "Rak Oak Gelap",
  "block.minecraft.dark_oak_sign": "Papan Tanda Oak Gelap",
  "block.minecraft.dark_oak_slab": "Papak Oak Gelap",
  "block.minecraft.dark_oak_stairs": "Tangga Oak Gelap",
  "block.minecraft.dark_oak_trapdoor": "Pintu Kolong Oak Gelap",
  "block.minecraft.dark_oak_wall_hanging_sign": "Papan Tanda Bergantung Dinding Oak Gelap",
  "block.minecraft.dark_oak_wall_sign": "Papan Tanda Dinding Oak Gelap",
  "block.minecraft.dark_oak_wood": "Kayu Oak Gelap",
  "block.minecraft.dark_prismarine": "Prismarin Gelap",
  "block.minecraft.dark_prismarine_slab": "Papak Prismarin Gelap",
  "block.minecraft.dark_prismarine_stairs": "Tangga Prismarin Gelap",
  "block.minecraft.daylight_detector": "Pengesan Cahaya Langit",
  "block.minecraft.dead_brain_coral": "Karang Otak Mati",
  "block.minecraft.dead_brain_coral_block": "Blok Karang Otak Mati",
  "block.minecraft.dead_brain_coral_fan": "Akar Bahar Otak Mati",
  "block.minecraft.dead_brain_coral_wall_fan": "Akar Bahar Dinding Otak Mati",
  "block.minecraft.dead_bubble_coral": "Karang Buih Mati",
  "block.minecraft.dead_bubble_coral_block": "Blok Karang Buih Mati",
  "block.minecraft.dead_bubble_coral_fan": "Akar Bahar Buih Mati",
  "block.minecraft.dead_bubble_coral_wall_fan": "Akar Bahar Dinding Buih Mati",
  "block.minecraft.dead_bush": "Semak Mati",
  "block.minecraft.dead_fire_coral": "Karang Api Mati",
  "block.minecraft.dead_fire_coral_block": "Blok Karang Api Mati",
  "block.minecraft.dead_fire_coral_fan": "Akar Bahar Api Mati",
  "block.minecraft.dead_fire_coral_wall_fan": "Akar Bahar Dinding Api Mati",
  "block.minecraft.dead_horn_coral": "Karang Tanduk Mati",
  "block.minecraft.dead_horn_coral_block": "Blok Karang Tanduk Mati",
  "block.minecraft.dead_horn_coral_fan": "Akar Bahar Tanduk Mati",
  "block.minecraft.dead_horn_coral_wall_fan": "Akar Bahar Dinding Tanduk Mati",
  "block.minecraft.dead_tube_coral": "Karang Tiub Mati",
  "block.minecraft.dead_tube_coral_block": "Blok Karang Tiub Mati",
  "block.minecraft.dead_tube_coral_fan": "Akar Bahar Tiub Mati",
  "block.minecraft.dead_tube_coral_wall_fan": "Akar Bahar Dinding Tiub Mati",
  "block.minecraft.decorated_pot": "Pasu Berhias",
  "block.minecraft.deepslate": "Batu Loh",
  "block.minecraft.deepslate_brick_slab": "Papak Batu Bata Loh",
  "block.minecraft.deepslate_brick_stairs": "Tangga Batu Bata Loh",
  "block.minecraft.deepslate_brick_wall": "Tembok Batu Bata Loh",
  "block.minecraft.deepslate_bricks": "Bata Loh",
  "block.minecraft.deepslate_coal_ore": "Bijih Arang Batu Loh",
  "block.minecraft.deepslate_copper_ore": "Bijih Tembaga Loh",
  "block.minecraft.deepslate_diamond_ore": "Bijih Berlian Loh",
  "block.minecraft.deepslate_emerald_ore": "Bijih Zamrud Loh",
  "block.minecraft.deepslate_gold_ore": "Bijih Emas Loh",
  "block.minecraft.deepslate_iron_ore": "Bijih Besi Loh",
  "block.minecraft.deepslate_lapis_ore": "Bijih Lapis Lazuli Loh",
  "block.minecraft.deepslate_redstone_ore": "Bijih Redstone Loh",
  "block.minecraft.deepslate_tile_slab": "Papak Genting Loh",
  "block.minecraft.deepslate_tile_stairs": "Tangga Genting Loh",
  "block.minecraft.deepslate_tile_wall": "Tembok Genting Loh",
  "block.minecraft.deepslate_tiles": "Genting Loh",
  "block.minecraft.detector_rail": "Landasan Pengesan",
  "block.minecraft.diamond_block": "Blok Berlian",
  "block.minecraft.diamond_ore": "Bijih Berlian",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Papak Diorit",
  "block.minecraft.diorite_stairs": "Tangga Diorit",
  "block.minecraft.diorite_wall": "Tembok Diorit",
  "block.minecraft.dirt": "Tanah",
  "block.minecraft.dirt_path": "Laluan Tanah",
  "block.minecraft.dispenser": "Pengagih",
  "block.minecraft.dragon_egg": "Telur Naga",
  "block.minecraft.dragon_head": "Kepala Naga",
  "block.minecraft.dragon_wall_head": "Kepala Dinding Naga",
  "block.minecraft.dried_ghast": "Ghast Kering",
  "block.minecraft.dried_kelp_block": "Blok Kelp Kering",
  "block.minecraft.dripstone_block": "Blok Batu Titis",
  "block.minecraft.dropper": "Penitis",
  "block.minecraft.emerald_block": "Blok Zamrud",
  "block.minecraft.emerald_ore": "Bijih Zamrud",
  "block.minecraft.enchanting_table": "Pertukangan Sihir",
  "block.minecraft.end_gateway": "Pintu Gerbang End",
  "block.minecraft.end_portal": "Gerbang End",
  "block.minecraft.end_portal_frame": "Bingkai Gerbang End",
  "block.minecraft.end_rod": "Batang End",
  "block.minecraft.end_stone": "Batu End",
  "block.minecraft.end_stone_brick_slab": "Papak Batu Bata End",
  "block.minecraft.end_stone_brick_stairs": "Tangga Bata Batu End",
  "block.minecraft.end_stone_brick_wall": "Tembok Bata Batu End",
  "block.minecraft.end_stone_bricks": "Bata Batu End",
  "block.minecraft.ender_chest": "Peti Ender",
  "block.minecraft.exposed_chiseled_copper": "Tembaga Terpahat Terdedah",
  "block.minecraft.exposed_copper": "Tembaga Terdedah",
  "block.minecraft.exposed_copper_bars": "Palang Tembaga Terdedah",
  "block.minecraft.exposed_copper_bulb": "Mentol Tembaga Terdedah",
  "block.minecraft.exposed_copper_chain": "Rantai Tembaga Terdedah",
  "block.minecraft.exposed_copper_chest": "Peti Tembaga Terdedah",
  "block.minecraft.exposed_copper_door": "Pintu Tembaga Terdedah",
  "block.minecraft.exposed_copper_golem_statue": "Patung Golem Tembaga Terdedah",
  "block.minecraft.exposed_copper_grate": "Jeriji Tembaga Terdedah",
  "block.minecraft.exposed_copper_lantern": "Tanglung Tembaga Terdedah",
  "block.minecraft.exposed_copper_trapdoor": "Pintu Kolong Tembaga Terdedah",
  "block.minecraft.exposed_cut_copper": "Tembaga Terpotong Terdedah",
  "block.minecraft.exposed_cut_copper_slab": "Papak Tembaga Terpotong Terdedah",
  "block.minecraft.exposed_cut_copper_stairs": "Tangga Tembaga Terpotong Terdedah",
  "block.minecraft.exposed_lightning_rod": "Pengalir Kilat Terdedah",
  "block.minecraft.farmland": "Tanah Ladang",
  "block.minecraft.fern": "Paku Pakis",
  "block.minecraft.fire": "Api",
  "block.minecraft.fire_coral": "Karang Api",
  "block.minecraft.fire_coral_block": "Blok Karang Api",
  "block.minecraft.fire_coral_fan": "Akar Bahar Api",
  "block.minecraft.fire_coral_wall_fan": "Akar Bahar Dinding Api",
  "block.minecraft.firefly_bush": "Semak Kelip-kelip",
  "block.minecraft.fletching_table": "Pertukangan Panah",
  "block.minecraft.flower_pot": "Pasu Bunga",
  "block.minecraft.flowering_azalea": "Azalea Bermekar",
  "block.minecraft.flowering_azalea_leaves": "Daun Azalea Bermekar",
  "block.minecraft.frogspawn": "Telur Katak",
  "block.minecraft.frosted_ice": "Ais Beku",
  "block.minecraft.furnace": "Relau",
  "block.minecraft.gilded_blackstone": "Batu Hitam Bersepuh",
  "block.minecraft.glass": "Kaca",
  "block.minecraft.glass_pane": "Anak Kaca",
  "block.minecraft.glow_lichen": "Liken Bersinar",
  "block.minecraft.glowstone": "Batu Menyala",
  "block.minecraft.gold_block": "Blok Emas",
  "block.minecraft.gold_ore": "Bijih Emas",
  "block.minecraft.golden_dandelion": "Bunga Paliman Emas",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Papak Granit",
  "block.minecraft.granite_stairs": "Tangga Granit",
  "block.minecraft.granite_wall": "Tembok Granit",
  "block.minecraft.grass": "Rumput",
  "block.minecraft.grass_block": "Blok Rumput",
  "block.minecraft.gravel": "Batu Kelikir",
  "block.minecraft.gray_banner": "Panji Kelabu",
  "block.minecraft.gray_bed": "Katil Kelabu",
  "block.minecraft.gray_candle": "Dian Kelabu",
  "block.minecraft.gray_candle_cake": "Kek Berdian Kelabu",
  "block.minecraft.gray_carpet": "Permaidani Kelabu",
  "block.minecraft.gray_concrete": "Konkrit Kelabu",
  "block.minecraft.gray_concrete_powder": "Serbuk Konkrit Kelabu",
  "block.minecraft.gray_glazed_terracotta": "Terakota Licau Kelabu",
  "block.minecraft.gray_shulker_box": "Kotak Shulker Kelabu",
  "block.minecraft.gray_stained_glass": "Kaca Berwarna Kelabu",
  "block.minecraft.gray_stained_glass_pane": "Anak Kaca Berwarna Kelabu",
  "block.minecraft.gray_terracotta": "Terakota Kelabu",
  "block.minecraft.gray_wool": "Bulu Kelabu",
  "block.minecraft.green_banner": "Panji Hijau",
  "block.minecraft.green_bed": "Katil Hijau",
  "block.minecraft.green_candle": "Dian Hijau",
  "block.minecraft.green_candle_cake": "Kek Berdian Hijau",
  "block.minecraft.green_carpet": "Permaidani Hijau",
  "block.minecraft.green_concrete": "Konkrit Hijau",
  "block.minecraft.green_concrete_powder": "Serbuk Konkrit Hijau",
  "block.minecraft.green_glazed_terracotta": "Terakota Licau Hijau",
  "block.minecraft.green_shulker_box": "Kotak Shulker Hijau",
  "block.minecraft.green_stained_glass": "Kaca Berwarna Hijau",
  "block.minecraft.green_stained_glass_pane": "Anak Kaca Berwarna Hijau",
  "block.minecraft.green_terracotta": "Terakota Hijau",
  "block.minecraft.green_wool": "Bulu Hijau",
  "block.minecraft.grindstone": "Batu Pengasah",
  "block.minecraft.hanging_roots": "Akar Tergantung",
  "block.minecraft.hay_block": "Bandela Jerami",
  "block.minecraft.heavy_core": "Teras Berat",
  "block.minecraft.heavy_weighted_pressure_plate": "Plat Tekanan Berat",
  "block.minecraft.honey_block": "Blok Madu",
  "block.minecraft.honeycomb_block": "Blok Indung Madu",
  "block.minecraft.hopper": "Corong Tuang",
  "block.minecraft.horn_coral": "Karang Tanduk",
  "block.minecraft.horn_coral_block": "Blok Karang Tanduk",
  "block.minecraft.horn_coral_fan": "Akar Bahar Tanduk",
  "block.minecraft.horn_coral_wall_fan": "Akar Bahar Dinding Tanduk",
  "block.minecraft.ice": "Ais",
  "block.minecraft.infested_chiseled_stone_bricks": "Bata Batu Terpahat Teremut",
  "block.minecraft.infested_cobblestone": "Batu Buntar Teremut",
  "block.minecraft.infested_cracked_stone_bricks": "Bata Batu Rekah Teremut",
  "block.minecraft.infested_deepslate": "Batu Loh Teremut",
  "block.minecraft.infested_mossy_stone_bricks": "Bata Batu Berlumut Teremut",
  "block.minecraft.infested_stone": "Batu Teremut",
  "block.minecraft.infested_stone_bricks": "Bata Batu Teremut",
  "block.minecraft.iron_bars": "Palang Besi",
  "block.minecraft.iron_block": "Blok Besi",
  "block.minecraft.iron_chain": "Rantai Besi",
  "block.minecraft.iron_door": "Pintu Besi",
  "block.minecraft.iron_ore": "Bijih Besi",
  "block.minecraft.iron_trapdoor": "Pintu Kolong Besi",
  "block.minecraft.jack_o_lantern": "Tanglung Labu",
  "block.minecraft.jigsaw": "Blok Suai-Jodoh",
  "block.minecraft.jukebox": "Peti Lagu",
  "block.minecraft.jungle_button": "Butang Rimba",
  "block.minecraft.jungle_door": "Pintu Kayu Rimba",
  "block.minecraft.jungle_fence": "Pagar Rimba",
  "block.minecraft.jungle_fence_gate": "Pintu Pagar Rimba",
  "block.minecraft.jungle_hanging_sign": "Papan Tanda Bergantung Rimba",
  "block.minecraft.jungle_leaves": "Daun Rimba",
  "block.minecraft.jungle_log": "Kayu Balak Rimba",
  "block.minecraft.jungle_planks": "Papan Kayu Rimba",
  "block.minecraft.jungle_pressure_plate": "Plat Tekanan Rimba",
  "block.minecraft.jungle_sapling": "Anak Pokok Rimba",
  "block.minecraft.jungle_shelf": "Rak Rimba",
  "block.minecraft.jungle_sign": "Papan Tanda Rimba",
  "block.minecraft.jungle_slab": "Papak Rimba",
  "block.minecraft.jungle_stairs": "Tangga Rimba",
  "block.minecraft.jungle_trapdoor": "Pintu Kolong Rimba",
  "block.minecraft.jungle_wall_hanging_sign": "Papan Tanda Bergantung Dinding Rimba",
  "block.minecraft.jungle_wall_sign": "Papan Tanda Dinding Rimba",
  "block.minecraft.jungle_wood": "Kayu Rimba",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Tumbuhan Kelp",
  "block.minecraft.ladder": "Tangga",
  "block.minecraft.lantern": "Tanglung",
  "block.minecraft.lapis_block": "Blok Lapis Lazuli",
  "block.minecraft.lapis_ore": "Bijih Lapis Lazuli",
  "block.minecraft.large_amethyst_bud": "Tunas Batu Kecubung Besar",
  "block.minecraft.large_fern": "Paku Pakis Besar",
  "block.minecraft.lava": "Lahar",
  "block.minecraft.lava_cauldron": "Kawah Lahar",
  "block.minecraft.leaf_litter": "Daun Kering",
  "block.minecraft.lectern": "Meja Syarahan",
  "block.minecraft.lever": "Tuas",
  "block.minecraft.light": "Cahaya",
  "block.minecraft.light_blue_banner": "Panji Biru Muda",
  "block.minecraft.light_blue_bed": "Katil Biru Muda",
  "block.minecraft.light_blue_candle": "Dian Biru Muda",
  "block.minecraft.light_blue_candle_cake": "Kek Berdian Biru Muda",
  "block.minecraft.light_blue_carpet": "Permaidani Biru Muda",
  "block.minecraft.light_blue_concrete": "Konkrit Biru Muda",
  "block.minecraft.light_blue_concrete_powder": "Serbuk Konkrit Biru Muda",
  "block.minecraft.light_blue_glazed_terracotta": "Terakota Licau Biru Muda",
  "block.minecraft.light_blue_shulker_box": "Kotak Shulker Biru Muda",
  "block.minecraft.light_blue_stained_glass": "Kaca Berwarna Biru Muda",
  "block.minecraft.light_blue_stained_glass_pane": "Anak Kaca Berwarna Biru Muda",
  "block.minecraft.light_blue_terracotta": "Terakota Biru Muda",
  "block.minecraft.light_blue_wool": "Bulu Biru Muda",
  "block.minecraft.light_gray_banner": "Panji Kelabu Muda",
  "block.minecraft.light_gray_bed": "Katil Kelabu Muda",
  "block.minecraft.light_gray_candle": "Dian Kelabu Muda",
  "block.minecraft.light_gray_candle_cake": "Kek Berdian Kelabu Muda",
  "block.minecraft.light_gray_carpet": "Permaidani Kelabu Muda",
  "block.minecraft.light_gray_concrete": "Konkrit Kelabu Muda",
  "block.minecraft.light_gray_concrete_powder": "Serbuk Konkrit Kelabu Muda",
  "block.minecraft.light_gray_glazed_terracotta": "Terakota Licau Kelabu Muda",
  "block.minecraft.light_gray_shulker_box": "Kotak Shulker Kelabu Muda",
  "block.minecraft.light_gray_stained_glass": "Kaca Berwarna Kelabu Muda",
  "block.minecraft.light_gray_stained_glass_pane": "Anak Kaca Berwarna Kelabu Muda",
  "block.minecraft.light_gray_terracotta": "Terakota Kelabu Muda",
  "block.minecraft.light_gray_wool": "Bulu Kelabu Muda",
  "block.minecraft.light_weighted_pressure_plate": "Plat Tekanan Ringan",
  "block.minecraft.lightning_rod": "Pengalir Kilat",
  "block.minecraft.lilac": "Lilac",
  "block.minecraft.lily_of_the_valley": "Bakung Lembah",
  "block.minecraft.lily_pad": "Tapak Teratai",
  "block.minecraft.lime_banner": "Panji Hijau Muda",
  "block.minecraft.lime_bed": "Katil Hijau Muda",
  "block.minecraft.lime_candle": "Dian Hijau Muda",
  "block.minecraft.lime_candle_cake": "Kek Berdian Hijau Muda",
  "block.minecraft.lime_carpet": "Permaidani Hijau Muda",
  "block.minecraft.lime_concrete": "Konkrit Hijau Muda",
  "block.minecraft.lime_concrete_powder": "Serbuk Konkrit Hijau Muda",
  "block.minecraft.lime_glazed_terracotta": "Terakota Licau Hijau Muda",
  "block.minecraft.lime_shulker_box": "Kotak Shulker Hijau Muda",
  "block.minecraft.lime_stained_glass": "Kaca Berwarna Hijau Muda",
  "block.minecraft.lime_stained_glass_pane": "Anak Kaca Berwarna Hijau Muda",
  "block.minecraft.lime_terracotta": "Terakota Hijau Muda",
  "block.minecraft.lime_wool": "Bulu Hijau Muda",
  "block.minecraft.lodestone": "Batu Magnet",
  "block.minecraft.loom": "Alat Tenun",
  "block.minecraft.magenta_banner": "Panji Magenta",
  "block.minecraft.magenta_bed": "Katil Magenta",
  "block.minecraft.magenta_candle": "Dian Magenta",
  "block.minecraft.magenta_candle_cake": "Kek Berdian Magenta",
  "block.minecraft.magenta_carpet": "Permaidani Magenta",
  "block.minecraft.magenta_concrete": "Konkrit Magenta",
  "block.minecraft.magenta_concrete_powder": "Serbuk Konkrit Magenta",
  "block.minecraft.magenta_glazed_terracotta": "Terakota Licau Magenta",
  "block.minecraft.magenta_shulker_box": "Kotak Shulker Magenta",
  "block.minecraft.magenta_stained_glass": "Kaca Berwarna Magenta",
  "block.minecraft.magenta_stained_glass_pane": "Anak Kaca Berwarna Magenta",
  "block.minecraft.magenta_terracotta": "Terakota Magenta",
  "block.minecraft.magenta_wool": "Bulu Magenta",
  "block.minecraft.magma_block": "Blok Magma",
  "block.minecraft.mangrove_button": "Butang Bakau",
  "block.minecraft.mangrove_door": "Pintu Bakau",
  "block.minecraft.mangrove_fence": "Pagar Bakau",
  "block.minecraft.mangrove_fence_gate": "Pintu Pagar Bakau",
  "block.minecraft.mangrove_hanging_sign": "Papan Tanda Bergantung Bakau",
  "block.minecraft.mangrove_leaves": "Daun Bakau",
  "block.minecraft.mangrove_log": "Kayu Balak Bakau",
  "block.minecraft.mangrove_planks": "Papan Bakau",
  "block.minecraft.mangrove_pressure_plate": "Plat Tekanan Bakau",
  "block.minecraft.mangrove_propagule": "Propagul Bakau",
  "block.minecraft.mangrove_roots": "Akar Bakau",
  "block.minecraft.mangrove_shelf": "Rak Bakau",
  "block.minecraft.mangrove_sign": "Papan Tanda Bakau",
  "block.minecraft.mangrove_slab": "Papak Bakau",
  "block.minecraft.mangrove_stairs": "Tangga Bakau",
  "block.minecraft.mangrove_trapdoor": "Pintu Kolong Bakau",
  "block.minecraft.mangrove_wall_hanging_sign": "Papan Tanda Bergantung Dinding Bakau",
  "block.minecraft.mangrove_wall_sign": "Papan Tanda Dinding Bakau",
  "block.minecraft.mangrove_wood": "Kayu Bakau",
  "block.minecraft.medium_amethyst_bud": "Tunas Batu Kecubung Sederhana",
  "block.minecraft.melon": "Tembikai",
  "block.minecraft.melon_stem": "Batang Tembikai",
  "block.minecraft.moss_block": "Blok Lumut",
  "block.minecraft.moss_carpet": "Litupan Lumut",
  "block.minecraft.mossy_cobblestone": "Batu Buntar Berlumut",
  "block.minecraft.mossy_cobblestone_slab": "Papak Batu Buntar Berlumut",
  "block.minecraft.mossy_cobblestone_stairs": "Tangga Batu Buntar Berlumut",
  "block.minecraft.mossy_cobblestone_wall": "Tembok Batu Buntar Berlumut",
  "block.minecraft.mossy_stone_brick_slab": "Papak Bata Batu Berlumut",
  "block.minecraft.mossy_stone_brick_stairs": "Tangga Batu Bata Berlumut",
  "block.minecraft.mossy_stone_brick_wall": "Tembok Bata Batu Berlumut",
  "block.minecraft.mossy_stone_bricks": "Bata Batu Berlumut",
  "block.minecraft.moving_piston": "Omboh Bergerak",
  "block.minecraft.mud": "Lumpur",
  "block.minecraft.mud_brick_slab": "Papak Bata Lumpur",
  "block.minecraft.mud_brick_stairs": "Tangga Bata Lumpur",
  "block.minecraft.mud_brick_wall": "Tembok Bata Lumpur",
  "block.minecraft.mud_bricks": "Bata Lumpur",
  "block.minecraft.muddy_mangrove_roots": "Akar Bakau Berlumpur",
  "block.minecraft.mushroom_stem": "Batang Cendawan",
  "block.minecraft.mycelium": "Miselium",
  "block.minecraft.nether_brick_fence": "Pagar Bata Nether",
  "block.minecraft.nether_brick_slab": "Papak Bata Nether",
  "block.minecraft.nether_brick_stairs": "Tangga Bata Nether",
  "block.minecraft.nether_brick_wall": "Tembok Bata Nether",
  "block.minecraft.nether_bricks": "Bata Nether",
  "block.minecraft.nether_gold_ore": "Bijih Emas Nether",
  "block.minecraft.nether_portal": "Gerbang Nether",
  "block.minecraft.nether_quartz_ore": "Bijih Kuarza Nether",
  "block.minecraft.nether_sprouts": "Pucuk Nether",
  "block.minecraft.nether_wart": "Ketuat Nether",
  "block.minecraft.nether_wart_block": "Blok Ketuat Nether",
  "block.minecraft.netherite_block": "Blok Netherit",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Blok Not",
  "block.minecraft.oak_button": "Butang Oak",
  "block.minecraft.oak_door": "Pintu Kayu Oak",
  "block.minecraft.oak_fence": "Pagar Oak",
  "block.minecraft.oak_fence_gate": "Pintu Pagar Oak",
  "block.minecraft.oak_hanging_sign": "Papan Tanda Bergantung Oak",
  "block.minecraft.oak_leaves": "Daun Oak",
  "block.minecraft.oak_log": "Kayu Balak Oak",
  "block.minecraft.oak_planks": "Papan Kayu Oak",
  "block.minecraft.oak_pressure_plate": "Plat Tekanan Oak",
  "block.minecraft.oak_sapling": "Anak Pokok Oak",
  "block.minecraft.oak_shelf": "Rak Oak",
  "block.minecraft.oak_sign": "Papan Tanda Oak",
  "block.minecraft.oak_slab": "Papak Oak",
  "block.minecraft.oak_stairs": "Tangga Oak",
  "block.minecraft.oak_trapdoor": "Pintu Kolong Oak",
  "block.minecraft.oak_wall_hanging_sign": "Papan Tanda Bergantung Dinding Oak",
  "block.minecraft.oak_wall_sign": "Papan Tanda Dinding Oak",
  "block.minecraft.oak_wood": "Kayu Oak",
  "block.minecraft.observer": "Pemerhati",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Lampu Katak Kehartalan",
  "block.minecraft.ominous_banner": "Panji Mengerikan",
  "block.minecraft.open_eyeblossom": "Puspa Mata Terbuka",
  "block.minecraft.orange_banner": "Panji Jingga",
  "block.minecraft.orange_bed": "Katil Jingga",
  "block.minecraft.orange_candle": "Dian Jingga",
  "block.minecraft.orange_candle_cake": "Kek Berdian Jingga",
  "block.minecraft.orange_carpet": "Permaidani Jingga",
  "block.minecraft.orange_concrete": "Konkrit Jingga",
  "block.minecraft.orange_concrete_powder": "Serbuk Konkrit Jingga",
  "block.minecraft.orange_glazed_terracotta": "Terakota Licau Jingga",
  "block.minecraft.orange_shulker_box": "Kotak Shulker Jingga",
  "block.minecraft.orange_stained_glass": "Kaca Berwarna Jingga",
  "block.minecraft.orange_stained_glass_pane": "Anak Kaca Berwarna Jingga",
  "block.minecraft.orange_terracotta": "Terakota Jingga",
  "block.minecraft.orange_tulip": "Tulip Jingga",
  "block.minecraft.orange_wool": "Bulu Jingga",
  "block.minecraft.oxeye_daisy": "Daisi Oxeye",
  "block.minecraft.oxidized_chiseled_copper": "Tembaga Terpahat Teroksida",
  "block.minecraft.oxidized_copper": "Tembaga Teroksida",
  "block.minecraft.oxidized_copper_bars": "Palang Tembaga Teroksida",
  "block.minecraft.oxidized_copper_bulb": "Mentol Tembaga Teroksida",
  "block.minecraft.oxidized_copper_chain": "Rantai Tembaga Teroksida",
  "block.minecraft.oxidized_copper_chest": "Peti Tembaga Teroksida",
  "block.minecraft.oxidized_copper_door": "Pintu Tembaga Teroksida",
  "block.minecraft.oxidized_copper_golem_statue": "Patung Golem Tembaga Teroksida",
  "block.minecraft.oxidized_copper_grate": "Jeriji Tembaga Teroksida",
  "block.minecraft.oxidized_copper_lantern": "Tanglung Tembaga Teroksida",
  "block.minecraft.oxidized_copper_trapdoor": "Pintu Kolong Tembaga Teroksida",
  "block.minecraft.oxidized_cut_copper": "Tembaga Terpotong Teroksida",
  "block.minecraft.oxidized_cut_copper_slab": "Papak Tembaga Terpotong Teroksida",
  "block.minecraft.oxidized_cut_copper_stairs": "Tangga Tembaga Terpotong Teroksida",
  "block.minecraft.oxidized_lightning_rod": "Pengalir Kilat Teroksida",
  "block.minecraft.packed_ice": "Ais Padat",
  "block.minecraft.packed_mud": "Lumpur Padat",
  "block.minecraft.pale_hanging_moss": "Lumut Penjalar Kemasi",
  "block.minecraft.pale_moss_block": "Blok Lumut Kemasi",
  "block.minecraft.pale_moss_carpet": "Litupan Lumut Kemasi",
  "block.minecraft.pale_oak_button": "Butang Oak Kemasi",
  "block.minecraft.pale_oak_door": "Pintu Oak Kemasi",
  "block.minecraft.pale_oak_fence": "Pagar Oak Kemasi",
  "block.minecraft.pale_oak_fence_gate": "Pintu Pagar Oak Kemasi",
  "block.minecraft.pale_oak_hanging_sign": "Papan Tanda Bergantung Oak Kemasi",
  "block.minecraft.pale_oak_leaves": "Daun Oak Kemasi",
  "block.minecraft.pale_oak_log": "Kayu Balak Oak Kemasi",
  "block.minecraft.pale_oak_planks": "Papan Kayu Oak Kemasi",
  "block.minecraft.pale_oak_pressure_plate": "Plat Tekanan Oak Kemasi",
  "block.minecraft.pale_oak_sapling": "Anak Pokok Oak Kemasi",
  "block.minecraft.pale_oak_shelf": "Rak Oak Kemasi",
  "block.minecraft.pale_oak_sign": "Papan Tanda Oak Kemasi",
  "block.minecraft.pale_oak_slab": "Papak Oak Kemasi",
  "block.minecraft.pale_oak_stairs": "Tangga Oak Kemasi",
  "block.minecraft.pale_oak_trapdoor": "Pintu Kolong Oak Kemasi",
  "block.minecraft.pale_oak_wall_hanging_sign": "Papan Tanda Bergantung Dinding Oak Kemasi",
  "block.minecraft.pale_oak_wall_sign": "Papan Tanda Dinding Oak Kemasi",
  "block.minecraft.pale_oak_wood": "Kayu Oak Kemasi",
  "block.minecraft.pearlescent_froglight": "Lampu Katak Kemutiaraan",
  "block.minecraft.peony": "Peony",
  "block.minecraft.petrified_oak_slab": "Papak Oak Membatu",
  "block.minecraft.piglin_head": "Kepala Piglin",
  "block.minecraft.piglin_wall_head": "Kepala Dinding Piglin",
  "block.minecraft.pink_banner": "Panji Merah Jambu",
  "block.minecraft.pink_bed": "Katil Merah Jambu",
  "block.minecraft.pink_candle": "Dian Merah Jambu",
  "block.minecraft.pink_candle_cake": "Kek Berdian Merah Jambu",
  "block.minecraft.pink_carpet": "Permaidani Merah Jambu",
  "block.minecraft.pink_concrete": "Konkrit Merah Jambu",
  "block.minecraft.pink_concrete_powder": "Serbuk Konkrit Merah Jambu",
  "block.minecraft.pink_glazed_terracotta": "Terakota Licau Merah Jambu",
  "block.minecraft.pink_petals": "Kelopak Merah Jambu",
  "block.minecraft.pink_shulker_box": "Kotak Shulker Merah Jambu",
  "block.minecraft.pink_stained_glass": "Kaca Berwarna Merah Jambu",
  "block.minecraft.pink_stained_glass_pane": "Anak Kaca Berwarna Merah Jambu",
  "block.minecraft.pink_terracotta": "Terakota Merah Jambu",
  "block.minecraft.pink_tulip": "Tulip Merah Jambu",
  "block.minecraft.pink_wool": "Bulu Merah Jambu",
  "block.minecraft.piston": "Omboh",
  "block.minecraft.piston_head": "Kepala Omboh",
  "block.minecraft.pitcher_crop": "Tanaman Periuk Kera",
  "block.minecraft.pitcher_plant": "Periuk Kera",
  "block.minecraft.player_head": "Kepala Pemain",
  "block.minecraft.player_head.named": "Kepala %s",
  "block.minecraft.player_wall_head": "Kepala Dinding Pemain",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Batu Titis Runcing",
  "block.minecraft.polished_andesite": "Andesit Digilap",
  "block.minecraft.polished_andesite_slab": "Papak Andesit Digilap",
  "block.minecraft.polished_andesite_stairs": "Tangga Andesit Digilap",
  "block.minecraft.polished_basalt": "Basalt Digilap",
  "block.minecraft.polished_blackstone": "Batu Hitam Digilap",
  "block.minecraft.polished_blackstone_brick_slab": "Papak Bata Batu Hitam Digilap",
  "block.minecraft.polished_blackstone_brick_stairs": "Tangga Bata Batu Hitam Digilap",
  "block.minecraft.polished_blackstone_brick_wall": "Tembok Bata Batu Hitam Digilap",
  "block.minecraft.polished_blackstone_bricks": "Bata Batu Hitam Digilap",
  "block.minecraft.polished_blackstone_button": "Butang Batu Hitam Digilap",
  "block.minecraft.polished_blackstone_pressure_plate": "Plat Tekanan Batu Hitam Digilap",
  "block.minecraft.polished_blackstone_slab": "Papak Batu Hitam Digilap",
  "block.minecraft.polished_blackstone_stairs": "Tangga Batu Hitam Digilap",
  "block.minecraft.polished_blackstone_wall": "Tembok Batu Hitam Digilap",
  "block.minecraft.polished_deepslate": "Batu Loh Digilap",
  "block.minecraft.polished_deepslate_slab": "Papak Batu Loh Digilap",
  "block.minecraft.polished_deepslate_stairs": "Tangga Batu Loh Digilap",
  "block.minecraft.polished_deepslate_wall": "Tembok Batu Loh Digilap",
  "block.minecraft.polished_diorite": "Diorit Digilap",
  "block.minecraft.polished_diorite_slab": "Papak Diorit Digilap",
  "block.minecraft.polished_diorite_stairs": "Tangga Diorit Digilap",
  "block.minecraft.polished_granite": "Granit Digilap",
  "block.minecraft.polished_granite_slab": "Papak Granit Digilap",
  "block.minecraft.polished_granite_stairs": "Tangga Granit Digilap",
  "block.minecraft.polished_tuff": "Tuf Digilap",
  "block.minecraft.polished_tuff_slab": "Papak Tuf Digilap",
  "block.minecraft.polished_tuff_stairs": "Tangga Tuf Digilap",
  "block.minecraft.polished_tuff_wall": "Tembok Tuf Digilap",
  "block.minecraft.poppy": "Popi",
  "block.minecraft.potatoes": "Kentang",
  "block.minecraft.potted_acacia_sapling": "Anak Pokok Akasia Berpasu",
  "block.minecraft.potted_allium": "Allium Berpasu",
  "block.minecraft.potted_azalea_bush": "Azalea Berpasu",
  "block.minecraft.potted_azure_bluet": "Azure Bluet Berpasu",
  "block.minecraft.potted_bamboo": "Buluh Berpasu",
  "block.minecraft.potted_birch_sapling": "Anak Pokok Birch Berpasu",
  "block.minecraft.potted_blue_orchid": "Orkid Biru Berpasu",
  "block.minecraft.potted_brown_mushroom": "Cendawan Perang Berpasu",
  "block.minecraft.potted_cactus": "Kaktus Berpasu",
  "block.minecraft.potted_cherry_sapling": "Anak Pokok Sakura Berpasu",
  "block.minecraft.potted_closed_eyeblossom": "Puspa Mata Tertutup Berpasu",
  "block.minecraft.potted_cornflower": "Cornflower Berpasu",
  "block.minecraft.potted_crimson_fungus": "Kulat Kirmizi Berpasu",
  "block.minecraft.potted_crimson_roots": "Akar Kirmizi Berpasu",
  "block.minecraft.potted_dandelion": "Bunga Paliman Berpasu",
  "block.minecraft.potted_dark_oak_sapling": "Anak Pokok Oak Gelap Berpasu",
  "block.minecraft.potted_dead_bush": "Semak Mati Berpasu",
  "block.minecraft.potted_fern": "Paku Pakis Berpasu",
  "block.minecraft.potted_flowering_azalea_bush": "Azalea Bermekar Berpasu",
  "block.minecraft.potted_golden_dandelion": "Bunga Paliman Emas Berpasu",
  "block.minecraft.potted_jungle_sapling": "Anak Pokok Rimba Berpasu",
  "block.minecraft.potted_lily_of_the_valley": "Bakung Lembah Berpasu",
  "block.minecraft.potted_mangrove_propagule": "Propagul Bakau Berpasu",
  "block.minecraft.potted_oak_sapling": "Anak Pokok Oak Berpasu",
  "block.minecraft.potted_open_eyeblossom": "Puspa Mata Terbuka Berpasu",
  "block.minecraft.potted_orange_tulip": "Tulip Jingga Berpasu",
  "block.minecraft.potted_oxeye_daisy": "Daisi Mata Lembu Berpasu",
  "block.minecraft.potted_pale_oak_sapling": "Anak Pokok Oak Kemasi Berpasu",
  "block.minecraft.potted_pink_tulip": "Tulip Merah Jambu Berpasu",
  "block.minecraft.potted_poppy": "Popi Berpasu",
  "block.minecraft.potted_red_mushroom": "Cendawan Merah Berpasu",
  "block.minecraft.potted_red_tulip": "Tulip Merah Berpasu",
  "block.minecraft.potted_spruce_sapling": "Anak Pokok Cemara Berpasu",
  "block.minecraft.potted_torchflower": "Tepus Api Berpasu",
  "block.minecraft.potted_warped_fungus": "Kulat Gila Berpasu",
  "block.minecraft.potted_warped_roots": "Akar Gila Berpasu",
  "block.minecraft.potted_white_tulip": "Tulip Putih Berpasu",
  "block.minecraft.potted_wither_rose": "Ros Wither Berpasu",
  "block.minecraft.powder_snow": "Salji Serbuk",
  "block.minecraft.powder_snow_cauldron": "Kawah Berisi Salji Serbuk",
  "block.minecraft.powered_rail": "Landasan Berkuasa",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Papak Bata Prismarin",
  "block.minecraft.prismarine_brick_stairs": "Tangga Bata Prismarin",
  "block.minecraft.prismarine_bricks": "Bata Prismarin",
  "block.minecraft.prismarine_slab": "Papak Prismarin",
  "block.minecraft.prismarine_stairs": "Tangga Prismarin",
  "block.minecraft.prismarine_wall": "Tembok Prismarin",
  "block.minecraft.pumpkin": "Labu",
  "block.minecraft.pumpkin_stem": "Batang Labu",
  "block.minecraft.purple_banner": "Panji Ungu",
  "block.minecraft.purple_bed": "Katil Ungu",
  "block.minecraft.purple_candle": "Dian Ungu",
  "block.minecraft.purple_candle_cake": "Kek Berdian Ungu",
  "block.minecraft.purple_carpet": "Permaidani Ungu",
  "block.minecraft.purple_concrete": "Konkrit Ungu",
  "block.minecraft.purple_concrete_powder": "Serbuk Konkrit Ungu",
  "block.minecraft.purple_glazed_terracotta": "Terakota Licau Ungu",
  "block.minecraft.purple_shulker_box": "Kotak Shulker Ungu",
  "block.minecraft.purple_stained_glass": "Kaca Berwarna Ungu",
  "block.minecraft.purple_stained_glass_pane": "Anak Kaca Berwarna Ungu",
  "block.minecraft.purple_terracotta": "Terakota Ungu",
  "block.minecraft.purple_wool": "Bulu Ungu",
  "block.minecraft.purpur_block": "Blok Purpur",
  "block.minecraft.purpur_pillar": "Tonggak Purpur",
  "block.minecraft.purpur_slab": "Papak Purpur",
  "block.minecraft.purpur_stairs": "Tangga Purpur",
  "block.minecraft.quartz_block": "Blok Kuarza",
  "block.minecraft.quartz_bricks": "Bata Kuarza",
  "block.minecraft.quartz_pillar": "Tonggak Kuarza",
  "block.minecraft.quartz_slab": "Papak Kuarza",
  "block.minecraft.quartz_stairs": "Tangga Kuarza",
  "block.minecraft.rail": "Landasan",
  "block.minecraft.raw_copper_block": "Blok Tembaga Mentah",
  "block.minecraft.raw_gold_block": "Blok Emas Mentah",
  "block.minecraft.raw_iron_block": "Blok Besi Mentah",
  "block.minecraft.red_banner": "Panji Merah",
  "block.minecraft.red_bed": "Katil Merah",
  "block.minecraft.red_candle": "Dian Merah",
  "block.minecraft.red_candle_cake": "Kek Berdian Merah",
  "block.minecraft.red_carpet": "Permaidani Merah",
  "block.minecraft.red_concrete": "Konkrit Merah",
  "block.minecraft.red_concrete_powder": "Serbuk Konkrit Merah",
  "block.minecraft.red_glazed_terracotta": "Terakota Licau Merah",
  "block.minecraft.red_mushroom": "Cendawan Merah",
  "block.minecraft.red_mushroom_block": "Blok Cendawan Merah",
  "block.minecraft.red_nether_brick_slab": "Papak Bata Nether Merah",
  "block.minecraft.red_nether_brick_stairs": "Tangga Bata Nether Merah",
  "block.minecraft.red_nether_brick_wall": "Tembok Bata Nether Merah",
  "block.minecraft.red_nether_bricks": "Bata Nether Merah",
  "block.minecraft.red_sand": "Pasir Merah",
  "block.minecraft.red_sandstone": "Batu Pasir Merah",
  "block.minecraft.red_sandstone_slab": "Papak Batu Pasir Merah",
  "block.minecraft.red_sandstone_stairs": "Tangga Batu Pasir Merah",
  "block.minecraft.red_sandstone_wall": "Tembok Batu Pasir Merah",
  "block.minecraft.red_shulker_box": "Kotak Shulker Merah",
  "block.minecraft.red_stained_glass": "Kaca Berwarna Merah",
  "block.minecraft.red_stained_glass_pane": "Anak Kaca Berwarna Merah",
  "block.minecraft.red_terracotta": "Terakota Merah",
  "block.minecraft.red_tulip": "Tulip Merah",
  "block.minecraft.red_wool": "Bulu Merah",
  "block.minecraft.redstone_block": "Blok Redstone",
  "block.minecraft.redstone_lamp": "Lampu Redstone",
  "block.minecraft.redstone_ore": "Bijih Redstone",
  "block.minecraft.redstone_torch": "Obor Redstone",
  "block.minecraft.redstone_wall_torch": "Obor Dinding Redstone",
  "block.minecraft.redstone_wire": "Wayar Redstone",
  "block.minecraft.reinforced_deepslate": "Batu Loh Bertetulang",
  "block.minecraft.repeater": "Pengulang Redstone",
  "block.minecraft.repeating_command_block": "Blok Perintah Berulang",
  "block.minecraft.resin_block": "Blok Damar",
  "block.minecraft.resin_brick_slab": "Papak Bata Damar",
  "block.minecraft.resin_brick_stairs": "Tangga Bata Damar",
  "block.minecraft.resin_brick_wall": "Tembok Bata Damar",
  "block.minecraft.resin_bricks": "Bata Damar",
  "block.minecraft.resin_clump": "Ketulan Damar",
  "block.minecraft.respawn_anchor": "Penambat Penjelmaan",
  "block.minecraft.rooted_dirt": "Tanah Berakar",
  "block.minecraft.rose_bush": "Pohon Mawar",
  "block.minecraft.sand": "Pasir",
  "block.minecraft.sandstone": "Batu Pasir",
  "block.minecraft.sandstone_slab": "Papak Batu Pasir",
  "block.minecraft.sandstone_stairs": "Tangga Batu Pasir",
  "block.minecraft.sandstone_wall": "Tembok Batu Pasir",
  "block.minecraft.scaffolding": "Perancah",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Mangkin Sculk",
  "block.minecraft.sculk_sensor": "Penderia Sculk",
  "block.minecraft.sculk_shrieker": "Peneriak Sculk",
  "block.minecraft.sculk_vein": "Urat Sculk",
  "block.minecraft.sea_lantern": "Tanglung Laut",
  "block.minecraft.sea_pickle": "Jeruk Laut",
  "block.minecraft.seagrass": "Rumput Laut",
  "block.minecraft.set_spawn": "Tempat jelma semula ditetapkan",
  "block.minecraft.short_dry_grass": "Rumput Kering Pendek",
  "block.minecraft.short_grass": "Rumput Pendek",
  "block.minecraft.shroomlight": "Lampu Cendawan",
  "block.minecraft.shulker_box": "Kotak Shulker",
  "block.minecraft.skeleton_skull": "Tengkorak Kerangka",
  "block.minecraft.skeleton_wall_skull": "Tengkorak Dinding Kerangka",
  "block.minecraft.slime_block": "Blok Lendir",
  "block.minecraft.small_amethyst_bud": "Tunas Batu Kecubung Kecil",
  "block.minecraft.small_dripleaf": "Daun Titis Kecil",
  "block.minecraft.smithing_table": "Pertukangan Besi",
  "block.minecraft.smoker": "Penyalai",
  "block.minecraft.smooth_basalt": "Basalt Licin",
  "block.minecraft.smooth_quartz": "Blok Kuarza Licin",
  "block.minecraft.smooth_quartz_slab": "Papak Kuarza Licin",
  "block.minecraft.smooth_quartz_stairs": "Tangga Kuarza Licin",
  "block.minecraft.smooth_red_sandstone": "Batu Pasir Merah Licin",
  "block.minecraft.smooth_red_sandstone_slab": "Papak Batu Pasir Merah Licin",
  "block.minecraft.smooth_red_sandstone_stairs": "Tangga Batu Pasir Merah Licin",
  "block.minecraft.smooth_sandstone": "Batu Pasir Licin",
  "block.minecraft.smooth_sandstone_slab": "Papak Batu Pasir Licin",
  "block.minecraft.smooth_sandstone_stairs": "Tangga Batu Pasir Licin",
  "block.minecraft.smooth_stone": "Batu Licin",
  "block.minecraft.smooth_stone_slab": "Papak Batu Licin",
  "block.minecraft.sniffer_egg": "Telur Penghidu",
  "block.minecraft.snow": "Salji",
  "block.minecraft.snow_block": "Blok Salji",
  "block.minecraft.soul_campfire": "Unggun Api Roh",
  "block.minecraft.soul_fire": "Api Roh",
  "block.minecraft.soul_lantern": "Tanglung Roh",
  "block.minecraft.soul_sand": "Pasir Roh",
  "block.minecraft.soul_soil": "Tanah Roh",
  "block.minecraft.soul_torch": "Obor Roh",
  "block.minecraft.soul_wall_torch": "Obor Dinding Roh",
  "block.minecraft.spawn.not_valid": "Anda tidak mempunyai katil atau penambat penjelmaan yang dicas atau katil tersebut terhalang",
  "block.minecraft.spawner": "Penjelma Raksasa",
  "block.minecraft.spawner.desc1": "Interaksi dengan Telur Penjelmaan:",
  "block.minecraft.spawner.desc2": "Tetapkan Jenis Makhluk",
  "block.minecraft.sponge": "Span",
  "block.minecraft.spore_blossom": "Bunga Spora",
  "block.minecraft.spruce_button": "Butang Cemara",
  "block.minecraft.spruce_door": "Pintu Kayu Cemara",
  "block.minecraft.spruce_fence": "Pagar Cemara",
  "block.minecraft.spruce_fence_gate": "Pintu Pagar Cemara",
  "block.minecraft.spruce_hanging_sign": "Papan Tanda Bergantung Cemara",
  "block.minecraft.spruce_leaves": "Daun Cemara",
  "block.minecraft.spruce_log": "Kayu Balak Cemara",
  "block.minecraft.spruce_planks": "Papan Kayu Cemara",
  "block.minecraft.spruce_pressure_plate": "Plat Tekanan Cemara",
  "block.minecraft.spruce_sapling": "Anak Pokok Cemara",
  "block.minecraft.spruce_shelf": "Rak Cemara",
  "block.minecraft.spruce_sign": "Papan Tanda Cemara",
  "block.minecraft.spruce_slab": "Papak Cemara",
  "block.minecraft.spruce_stairs": "Tangga Cemara",
  "block.minecraft.spruce_trapdoor": "Pintu Kolong Cemara",
  "block.minecraft.spruce_wall_hanging_sign": "Papan Tanda Bergantung Dinding Cemara",
  "block.minecraft.spruce_wall_sign": "Papan Tanda Dinding Cemara",
  "block.minecraft.spruce_wood": "Kayu Cemara",
  "block.minecraft.sticky_piston": "Omboh Melekit",
  "block.minecraft.stone": "Batu",
  "block.minecraft.stone_brick_slab": "Papak Batu Bata",
  "block.minecraft.stone_brick_stairs": "Anak Tangga Batu Bata",
  "block.minecraft.stone_brick_wall": "Tembok Bata Batu",
  "block.minecraft.stone_bricks": "Bata Batu",
  "block.minecraft.stone_button": "Butang Batu",
  "block.minecraft.stone_pressure_plate": "Plat Tekanan Batu",
  "block.minecraft.stone_slab": "Papak Batu",
  "block.minecraft.stone_stairs": "Tangga Batu",
  "block.minecraft.stonecutter": "Pemotong Batu",
  "block.minecraft.stripped_acacia_log": "Kayu Balak Akasia Terkupas Kulit",
  "block.minecraft.stripped_acacia_wood": "Kayu Akasia Terkupas Kulit",
  "block.minecraft.stripped_bamboo_block": "Blok Buluh Terkupas Kulit",
  "block.minecraft.stripped_birch_log": "Kayu Balak Birch Terkupas Kulit",
  "block.minecraft.stripped_birch_wood": "Kayu Birch Terkupas Kulit",
  "block.minecraft.stripped_cherry_log": "Kayu Balak Sakura Terkupas Kulit",
  "block.minecraft.stripped_cherry_wood": "Kayu Sakura Terkupas Kulit",
  "block.minecraft.stripped_crimson_hyphae": "Hifa Kirmizi Terkupas Kulit",
  "block.minecraft.stripped_crimson_stem": "Batang Kirmizi Terkupas Kulit",
  "block.minecraft.stripped_dark_oak_log": "Kayu Balak Oak Gelap Terkupas Kulit",
  "block.minecraft.stripped_dark_oak_wood": "Kayu Oak Gelap Terkupas Kulit",
  "block.minecraft.stripped_jungle_log": "Kayu Balak Rimba Terkupas Kulit",
  "block.minecraft.stripped_jungle_wood": "Kayu Rimba Terkupas Kulit",
  "block.minecraft.stripped_mangrove_log": "Kayu Balak Bakau Terkupas Kulit",
  "block.minecraft.stripped_mangrove_wood": "Kayu Bakau Terkupas Kulit",
  "block.minecraft.stripped_oak_log": "Kayu Balak Oak Terkupas Kulit",
  "block.minecraft.stripped_oak_wood": "Kayu Oak Terkupas Kulit",
  "block.minecraft.stripped_pale_oak_log": "Kayu Balak Oak Kemasi Terkupas Kulit",
  "block.minecraft.stripped_pale_oak_wood": "Kayu Oak Kemasi Terkupas Kulit",
  "block.minecraft.stripped_spruce_log": "Kayu Balak Cemara Terkupas Kulit",
  "block.minecraft.stripped_spruce_wood": "Kayu Cemara Terkupas Kulit",
  "block.minecraft.stripped_warped_hyphae": "Hifa Gila Terkupas Kulit",
  "block.minecraft.stripped_warped_stem": "Batang Gila Terkupas Kulit",
  "block.minecraft.structure_block": "Blok Struktur",
  "block.minecraft.structure_void": "Struktur Kekosongan",
  "block.minecraft.sugar_cane": "Tebu",
  "block.minecraft.sunflower": "Bunga Matahari",
  "block.minecraft.suspicious_gravel": "Batu Kelikir Mencurigakan",
  "block.minecraft.suspicious_sand": "Pasir Mencurigakan",
  "block.minecraft.sweet_berry_bush": "Pohon Beri Manis",
  "block.minecraft.tall_dry_grass": "Rumput Kering Panjang",
  "block.minecraft.tall_grass": "Rumput Panjang",
  "block.minecraft.tall_seagrass": "Rumput Laut Panjang",
  "block.minecraft.target": "Sasaran",
  "block.minecraft.terracotta": "Terakota",
  "block.minecraft.test_block": "Blok Ujian",
  "block.minecraft.test_instance_block": "Blok Tika Ujian",
  "block.minecraft.tinted_glass": "Cermin Gelap",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Letupan TNT dinyahdayakan",
  "block.minecraft.torch": "Obor",
  "block.minecraft.torchflower": "Tepus Api",
  "block.minecraft.torchflower_crop": "Tanaman Tepus Api",
  "block.minecraft.trapped_chest": "Peti Perangkap",
  "block.minecraft.trial_spawner": "Penjelma Ujian",
  "block.minecraft.tripwire": "Tali Belantik",
  "block.minecraft.tripwire_hook": "Penyangkuk Tali Belantik",
  "block.minecraft.tube_coral": "Karang Tiub",
  "block.minecraft.tube_coral_block": "Blok Karang Tiub",
  "block.minecraft.tube_coral_fan": "Akar Bahar Tiub",
  "block.minecraft.tube_coral_wall_fan": "Akar Bahar Dinding Tiub",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Papak Bata Tuf",
  "block.minecraft.tuff_brick_stairs": "Tangga Bata Tuf",
  "block.minecraft.tuff_brick_wall": "Tembok Bata Tuf",
  "block.minecraft.tuff_bricks": "Bata Tuf",
  "block.minecraft.tuff_slab": "Papak Tuf",
  "block.minecraft.tuff_stairs": "Tangga Tuf",
  "block.minecraft.tuff_wall": "Tembok Tuf",
  "block.minecraft.turtle_egg": "Telur Penyu",
  "block.minecraft.twisting_vines": "Penjalar Memulas",
  "block.minecraft.twisting_vines_plant": "Pokok Penjalar Memulas",
  "block.minecraft.vault": "Peti Kebal",
  "block.minecraft.verdant_froglight": "Lampu Katak Kehijauan",
  "block.minecraft.vine": "Penjalar",
  "block.minecraft.void_air": "Udara Kekosongan",
  "block.minecraft.wall_torch": "Obor Dinding",
  "block.minecraft.warped_button": "Butang Gila",
  "block.minecraft.warped_door": "Pintu Gila",
  "block.minecraft.warped_fence": "Pagar Gila",
  "block.minecraft.warped_fence_gate": "Pintu Pagar Gila",
  "block.minecraft.warped_fungus": "Kulat Gila",
  "block.minecraft.warped_hanging_sign": "Papan Tanda Bergantung Gila",
  "block.minecraft.warped_hyphae": "Hifa Gila",
  "block.minecraft.warped_nylium": "Nilium Gila",
  "block.minecraft.warped_planks": "Papan Gila",
  "block.minecraft.warped_pressure_plate": "Plat Tekanan Gila",
  "block.minecraft.warped_roots": "Akar Gila",
  "block.minecraft.warped_shelf": "Rak Gila",
  "block.minecraft.warped_sign": "Papan Tanda Gila",
  "block.minecraft.warped_slab": "Papak Gila",
  "block.minecraft.warped_stairs": "Tangga Gila",
  "block.minecraft.warped_stem": "Batang Gila",
  "block.minecraft.warped_trapdoor": "Pintu Kolong Gila",
  "block.minecraft.warped_wall_hanging_sign": "Papan Tanda Bergantung Dinding Gila",
  "block.minecraft.warped_wall_sign": "Papan Tanda Dinding Gila",
  "block.minecraft.warped_wart_block": "Blok Ketuat Gila",
  "block.minecraft.water": "Air",
  "block.minecraft.water_cauldron": "Kawah Air",
  "block.minecraft.waxed_chiseled_copper": "Tembaga Terpahat Berlilin",
  "block.minecraft.waxed_copper_bars": "Palang Tembaga Berlilin",
  "block.minecraft.waxed_copper_block": "Blok Tembaga Berlilin",
  "block.minecraft.waxed_copper_bulb": "Mentol Tembaga Berlilin",
  "block.minecraft.waxed_copper_chain": "Rantai Tembaga Berlilin",
  "block.minecraft.waxed_copper_chest": "Peti Tembaga Berlilin",
  "block.minecraft.waxed_copper_door": "Pintu Tembaga Berlilin",
  "block.minecraft.waxed_copper_golem_statue": "Patung Golem Tembaga Berlilin",
  "block.minecraft.waxed_copper_grate": "Jeriji Tembaga Berlilin",
  "block.minecraft.waxed_copper_lantern": "Tanglung Tembaga Berlilin",
  "block.minecraft.waxed_copper_trapdoor": "Pintu Kolong Tembaga Berlilin",
  "block.minecraft.waxed_cut_copper": "Tembaga Terpotong Berlilin",
  "block.minecraft.waxed_cut_copper_slab": "Papak Tembaga Terpotong Berlilin",
  "block.minecraft.waxed_cut_copper_stairs": "Tangga Tembaga Terpotong Berlilin",
  "block.minecraft.waxed_exposed_chiseled_copper": "Tembaga Terpahat Terdedah Berlilin",
  "block.minecraft.waxed_exposed_copper": "Tembaga Terdedah Berlilin",
  "block.minecraft.waxed_exposed_copper_bars": "Palang Tembaga Terdedah Berlilin",
  "block.minecraft.waxed_exposed_copper_bulb": "Mentol Tembaga Terdedah Berlilin",
  "block.minecraft.waxed_exposed_copper_chain": "Rantai Tembaga Terdedah Berlilin",
  "block.minecraft.waxed_exposed_copper_chest": "Peti Tembaga Terdedah Berlilin",
  "block.minecraft.waxed_exposed_copper_door": "Pintu Tembaga Terdedah Berlilin",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Patung Golem Tembaga Terdedah Berlilin",
  "block.minecraft.waxed_exposed_copper_grate": "Jeriji Tembaga Terdedah Berlilin",
  "block.minecraft.waxed_exposed_copper_lantern": "Tanglung Tembaga Terdedah Berlilin",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Pintu Kolong Tembaga Terdedah Berlilin",
  "block.minecraft.waxed_exposed_cut_copper": "Tembaga Terpotong Terdedah Berlilin",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Papak Tembaga Terpotong Terdedah Berlilin",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Tangga Tembaga Terpotong Terdedah Berlilin",
  "block.minecraft.waxed_exposed_lightning_rod": "Pengalir Kilat Terdedah Berlilin",
  "block.minecraft.waxed_lightning_rod": "Pengalir Kilat Berlilin",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Tembaga Terpahat Teroksida Berlilin",
  "block.minecraft.waxed_oxidized_copper": "Tembaga Teroksida Berlilin",
  "block.minecraft.waxed_oxidized_copper_bars": "Palang Tembaga Teroksida Berlilin",
  "block.minecraft.waxed_oxidized_copper_bulb": "Mentol Tembaga Teroksida Berlilin",
  "block.minecraft.waxed_oxidized_copper_chain": "Rantai Tembaga Teroksida Berlilin",
  "block.minecraft.waxed_oxidized_copper_chest": "Peti Tembaga Teroksida Berlilin",
  "block.minecraft.waxed_oxidized_copper_door": "Pintu Tembaga Teroksida Berlilin",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Patung Golem Tembaga Teroksida Berlilin",
  "block.minecraft.waxed_oxidized_copper_grate": "Jeriji Tembaga Teroksida Berlilin",
  "block.minecraft.waxed_oxidized_copper_lantern": "Tanglung Tembaga Teroksida Berlilin",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Pintu Kolong Tembaga Teroksida Berlilin",
  "block.minecraft.waxed_oxidized_cut_copper": "Tembaga Terpotong Teroksida Berlilin",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Papak Tembaga Terpotong Teroksida Berlilin",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Tangga Tembaga Terpotong Teroksida Berlilin",
  "block.minecraft.waxed_oxidized_lightning_rod": "Pengalir Kilat Teroksida Berlilin",
  "block.minecraft.waxed_weathered_chiseled_copper": "Tembaga Terpahat Terluluhawa Berlilin",
  "block.minecraft.waxed_weathered_copper": "Tembaga Terluluhawa Berlilin",
  "block.minecraft.waxed_weathered_copper_bars": "Palang Tembaga Terluluhawa Berlilin",
  "block.minecraft.waxed_weathered_copper_bulb": "Mentol Tembaga Terluluhawa Berlilin",
  "block.minecraft.waxed_weathered_copper_chain": "Rantai Tembaga Terluluhawa Berlilin",
  "block.minecraft.waxed_weathered_copper_chest": "Peti Tembaga Terluluhawa Berlilin",
  "block.minecraft.waxed_weathered_copper_door": "Pintu Tembaga Terluluhawa Berlilin",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Patung Golem Tembaga Terluluhawa Berlilin",
  "block.minecraft.waxed_weathered_copper_grate": "Jeriji Tembaga Terluluhawa Berlilin",
  "block.minecraft.waxed_weathered_copper_lantern": "Tanglung Tembaga Terluluhawa Berlilin",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Pintu Kolong Tembaga Terluluhawa Berlilin",
  "block.minecraft.waxed_weathered_cut_copper": "Tembaga Terpotong Terluluhawa Berlilin",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Papak Tembaga Terpotong Terluluhawa Berlilin",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Tangga Tembaga Terpotong Terluluhawa Berlilin",
  "block.minecraft.waxed_weathered_lightning_rod": "Pengalir Kilat Terluluhawa Berlilin",
  "block.minecraft.weathered_chiseled_copper": "Tembaga Terpahat Terluluhawa",
  "block.minecraft.weathered_copper": "Tembaga Terluluhawa",
  "block.minecraft.weathered_copper_bars": "Palang Tembaga Terluluhawa",
  "block.minecraft.weathered_copper_bulb": "Mentol Tembaga Terluluhawa",
  "block.minecraft.weathered_copper_chain": "Rantai Tembaga Terluluhawa",
  "block.minecraft.weathered_copper_chest": "Peti Tembaga Terluluhawa",
  "block.minecraft.weathered_copper_door": "Pintu Tembaga Terluluhawa",
  "block.minecraft.weathered_copper_golem_statue": "Patung Golem Tembaga Terluluhawa",
  "block.minecraft.weathered_copper_grate": "Jeriji Tembaga Terluluhawa",
  "block.minecraft.weathered_copper_lantern": "Tanglung Tembaga Terluluhawa",
  "block.minecraft.weathered_copper_trapdoor": "Pintu Kolong Tembaga Terluluhawa",
  "block.minecraft.weathered_cut_copper": "Tembaga Terpotong Terluluhawa",
  "block.minecraft.weathered_cut_copper_slab": "Papak Tembaga Terpotong Terluluhawa",
  "block.minecraft.weathered_cut_copper_stairs": "Tangga Tembaga Terpotong Terluluhawa",
  "block.minecraft.weathered_lightning_rod": "Pengalir Kilat Terluluhawa",
  "block.minecraft.weeping_vines": "Penjalar Menjulai",
  "block.minecraft.weeping_vines_plant": "Pokok Penjalar Menjulai",
  "block.minecraft.wet_sponge": "Span Basah",
  "block.minecraft.wheat": "Tanaman Gandum",
  "block.minecraft.white_banner": "Panji Putih",
  "block.minecraft.white_bed": "Katil Putih",
  "block.minecraft.white_candle": "Dian Putih",
  "block.minecraft.white_candle_cake": "Kek Berdian Putih",
  "block.minecraft.white_carpet": "Permaidani Putih",
  "block.minecraft.white_concrete": "Konkrit Putih",
  "block.minecraft.white_concrete_powder": "Serbuk Konkrit Putih",
  "block.minecraft.white_glazed_terracotta": "Terakota Licau Putih",
  "block.minecraft.white_shulker_box": "Kotak Shulker Putih",
  "block.minecraft.white_stained_glass": "Kaca Berwarna Putih",
  "block.minecraft.white_stained_glass_pane": "Anak Kaca Berwarna Putih",
  "block.minecraft.white_terracotta": "Terakota Putih",
  "block.minecraft.white_tulip": "Tulip Putih",
  "block.minecraft.white_wool": "Bulu Putih",
  "block.minecraft.wildflowers": "Bunga Liar",
  "block.minecraft.wither_rose": "Mawar Wither",
  "block.minecraft.wither_skeleton_skull": "Tengkorak Kerangka Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Tengkorak Dinding Kerangka Wither",
  "block.minecraft.yellow_banner": "Panji Kuning",
  "block.minecraft.yellow_bed": "Katil Kuning",
  "block.minecraft.yellow_candle": "Dian Kuning",
  "block.minecraft.yellow_candle_cake": "Kek Berdian Kuning",
  "block.minecraft.yellow_carpet": "Permaidani Kuning",
  "block.minecraft.yellow_concrete": "Konkrit Kuning",
  "block.minecraft.yellow_concrete_powder": "Serbuk Konkrit Kuning",
  "block.minecraft.yellow_glazed_terracotta": "Terakota Licau Kuning",
  "block.minecraft.yellow_shulker_box": "Kotak Shulker Kuning",
  "block.minecraft.yellow_stained_glass": "Kaca Berwarna Kuning",
  "block.minecraft.yellow_stained_glass_pane": "Anak Kaca Berwarna Kuning",
  "block.minecraft.yellow_terracotta": "Terakota Kuning",
  "block.minecraft.yellow_wool": "Bulu Kuning",
  "block.minecraft.zombie_head": "Kepala Zombi",
  "block.minecraft.zombie_wall_head": "Kepala Dinding Zombi",
  "item.minecraft.acacia_boat": "Sampan Akasia",
  "item.minecraft.acacia_chest_boat": "Sampan Akasia dengan Peti",
  "item.minecraft.allay_spawn_egg": "Telur Penjelmaan Pepari",
  "item.minecraft.amethyst_shard": "Beling Batu Kecubung",
  "item.minecraft.angler_pottery_shard": "Beling Tembikar Pengail",
  "item.minecraft.angler_pottery_sherd": "Beling Tembikar Pengail",
  "item.minecraft.apple": "Epal",
  "item.minecraft.archer_pottery_shard": "Beling Tembikar Pemanah",
  "item.minecraft.archer_pottery_sherd": "Beling Tembikar Pemanah",
  "item.minecraft.armadillo_scute": "Skut Tenggiling",
  "item.minecraft.armadillo_spawn_egg": "Telur Penjelmaan Tenggiling",
  "item.minecraft.armor_stand": "Pempamer Zirah",
  "item.minecraft.arms_up_pottery_shard": "Beling Tembikar Angkat Tangan",
  "item.minecraft.arms_up_pottery_sherd": "Beling Tembikar Angkat Tangan",
  "item.minecraft.arrow": "Anak Panah",
  "item.minecraft.axolotl_bucket": "Baldi Axolotl",
  "item.minecraft.axolotl_spawn_egg": "Telur Penjelmaan Axolotl",
  "item.minecraft.baked_potato": "Kentang Bakar",
  "item.minecraft.bamboo_chest_raft": "Rakit Buluh dengan Peti",
  "item.minecraft.bamboo_raft": "Rakit Buluh",
  "item.minecraft.bat_spawn_egg": "Telur Penjelmaan Kelawar",
  "item.minecraft.bee_spawn_egg": "Telur Penjelmaan Lebah",
  "item.minecraft.beef": "Daging Lembu Mentah",
  "item.minecraft.beetroot": "Ubi Bit",
  "item.minecraft.beetroot_seeds": "Benih Ubi Bit",
  "item.minecraft.beetroot_soup": "Sup Ubi Bit",
  "item.minecraft.birch_boat": "Sampan Birch",
  "item.minecraft.birch_chest_boat": "Sampan Birch dengan Peti",
  "item.minecraft.black_bundle": "Guni Hitam",
  "item.minecraft.black_dye": "Pewarna Hitam",
  "item.minecraft.black_harness": "Sela Hitam",
  "item.minecraft.blade_pottery_shard": "Beling Tembikar Bilah",
  "item.minecraft.blade_pottery_sherd": "Beling Tembikar Bilah",
  "item.minecraft.blaze_powder": "Serbuk Kemamang",
  "item.minecraft.blaze_rod": "Tongkat Kemamang",
  "item.minecraft.blaze_spawn_egg": "Telur Penjelmaan Kemamang",
  "item.minecraft.blue_bundle": "Guni Biru",
  "item.minecraft.blue_dye": "Pewarna Biru",
  "item.minecraft.blue_egg": "Telur Biru",
  "item.minecraft.blue_harness": "Sela Biru",
  "item.minecraft.bogged_spawn_egg": "Telur Penjelmaan Lumutan",
  "item.minecraft.bolt_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Hiasan Zirah Selak",
  "item.minecraft.bone": "Tulang",
  "item.minecraft.bone_meal": "Serbuk Tulang",
  "item.minecraft.book": "Buku",
  "item.minecraft.bordure_indented_banner_pattern": "Corak Panji Bingkai Bergerigi",
  "item.minecraft.bow": "Busur",
  "item.minecraft.bowl": "Mangkuk",
  "item.minecraft.bread": "Roti",
  "item.minecraft.breeze_rod": "Tongkat Halimbubu",
  "item.minecraft.breeze_spawn_egg": "Telur Penjelmaan Halimbubu",
  "item.minecraft.brewer_pottery_shard": "Beling Tembikar Peramu",
  "item.minecraft.brewer_pottery_sherd": "Beling Tembikar Peramu",
  "item.minecraft.brewing_stand": "Tapak Membru",
  "item.minecraft.brick": "Bata",
  "item.minecraft.brown_bundle": "Guni Perang",
  "item.minecraft.brown_dye": "Pewarna Perang",
  "item.minecraft.brown_egg": "Telur Perang",
  "item.minecraft.brown_harness": "Sela Perang",
  "item.minecraft.brush": "Berus",
  "item.minecraft.bucket": "Baldi",
  "item.minecraft.bundle": "Guni",
  "item.minecraft.bundle.empty": "Kosong",
  "item.minecraft.bundle.empty.description": "Boleh memegang satu timbunan item yang bercampur",
  "item.minecraft.bundle.full": "Penuh",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Beling Tembikar Bakar",
  "item.minecraft.burn_pottery_sherd": "Beling Tembikar Bakar",
  "item.minecraft.camel_husk_spawn_egg": "Telur Penjelmaan Unta Reputan",
  "item.minecraft.camel_spawn_egg": "Telur Penjelmaan Unta",
  "item.minecraft.carrot": "Lobak",
  "item.minecraft.carrot_on_a_stick": "Lobak pada Kayu",
  "item.minecraft.cat_spawn_egg": "Telur Penjelmaan Kucing",
  "item.minecraft.cauldron": "Kawah",
  "item.minecraft.cave_spider_spawn_egg": "Telur Penjelmaan Lelabah Gua",
  "item.minecraft.chainmail_boots": "But Rantai",
  "item.minecraft.chainmail_chestplate": "Zirah Dada Rantai",
  "item.minecraft.chainmail_helmet": "Ketopong Rantai",
  "item.minecraft.chainmail_leggings": "Zirah Kaki Rantai",
  "item.minecraft.charcoal": "Arang",
  "item.minecraft.cherry_boat": "Sampan Sakura",
  "item.minecraft.cherry_chest_boat": "Sampan Sakura dengan Peti",
  "item.minecraft.chest_minecart": "Kereta Lombong dengan Peti",
  "item.minecraft.chicken": "Ayam Mentah",
  "item.minecraft.chicken_spawn_egg": "Telur Penjelmaan Ayam",
  "item.minecraft.chorus_fruit": "Buah Korus",
  "item.minecraft.clay_ball": "Bebola Tanah Liat",
  "item.minecraft.clock": "Jam",
  "item.minecraft.coal": "Arang Batu",
  "item.minecraft.coast_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Hiasan Zirah Sisir",
  "item.minecraft.cocoa_beans": "Biji Koko",
  "item.minecraft.cod": "Kod Mentah",
  "item.minecraft.cod_bucket": "Baldi Ikan Kod",
  "item.minecraft.cod_spawn_egg": "Telur Penjelmaan Kod",
  "item.minecraft.command_block_minecart": "Kereta Lombong dengan Blok Perintah",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Stik",
  "item.minecraft.cooked_chicken": "Ayam Masak",
  "item.minecraft.cooked_cod": "Kod Masak",
  "item.minecraft.cooked_mutton": "Daging Biri-Biri Masak",
  "item.minecraft.cooked_porkchop": "Daging Khinzir Masak",
  "item.minecraft.cooked_rabbit": "Arnab Masak",
  "item.minecraft.cooked_salmon": "Salmon Masak",
  "item.minecraft.cookie": "Biskut",
  "item.minecraft.copper_axe": "Kapak Tembaga",
  "item.minecraft.copper_boots": "But Tembaga",
  "item.minecraft.copper_chestplate": "Zirah Dada Tembaga",
  "item.minecraft.copper_golem_spawn_egg": "Telur Penjelmaan Golem Tembaga",
  "item.minecraft.copper_helmet": "Ketopong Tembaga",
  "item.minecraft.copper_hoe": "Cangkul Tembaga",
  "item.minecraft.copper_horse_armor": "Zirah Kuda Tembaga",
  "item.minecraft.copper_ingot": "Jongkong Tembaga",
  "item.minecraft.copper_leggings": "Zirah Kaki Tembaga",
  "item.minecraft.copper_nautilus_armor": "Zirah Genggeng Tembaga",
  "item.minecraft.copper_nugget": "Nuget Tembaga",
  "item.minecraft.copper_pickaxe": "Beliung Tembaga",
  "item.minecraft.copper_shovel": "Penyodok Tembaga",
  "item.minecraft.copper_spear": "Tombak Tembaga",
  "item.minecraft.copper_sword": "Pedang Tembaga",
  "item.minecraft.cow_spawn_egg": "Telur Penjelmaan Lembu",
  "item.minecraft.creaking_spawn_egg": "Telur Penjelmaan Deritan",
  "item.minecraft.creeper_banner_pattern": "Corak Panji",
  "item.minecraft.creeper_banner_pattern.desc": "Lambang Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Corak Panji Lambang Creeper",
  "item.minecraft.creeper_spawn_egg": "Telur Penjelmaan Creeper",
  "item.minecraft.crossbow": "Busur Silang",
  "item.minecraft.crossbow.projectile": "Peluru:",
  "item.minecraft.crossbow.projectile.multiple": "Peluru: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Peluru: %s",
  "item.minecraft.cyan_bundle": "Guni Sian",
  "item.minecraft.cyan_dye": "Pewarna Sian",
  "item.minecraft.cyan_harness": "Sela Sian",
  "item.minecraft.danger_pottery_shard": "Beling Tembikar Bahaya",
  "item.minecraft.danger_pottery_sherd": "Beling Tembikar Bahaya",
  "item.minecraft.dark_oak_boat": "Sampan Oak Gelap",
  "item.minecraft.dark_oak_chest_boat": "Sampan Oak Gelap dengan Peti",
  "item.minecraft.debug_stick": "Batang Penyahpepijat",
  "item.minecraft.debug_stick.empty": "%s tidak mempunyai sifat",
  "item.minecraft.debug_stick.select": "telah memilih \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" kepada %s",
  "item.minecraft.diamond": "Berlian",
  "item.minecraft.diamond_axe": "Kapak Berlian",
  "item.minecraft.diamond_boots": "But Berlian",
  "item.minecraft.diamond_chestplate": "Zirah Dada Berlian",
  "item.minecraft.diamond_helmet": "Ketopong Berlian",
  "item.minecraft.diamond_hoe": "Cangkul Berlian",
  "item.minecraft.diamond_horse_armor": "Zirah Kuda Berlian",
  "item.minecraft.diamond_leggings": "Zirah Kaki Berlian",
  "item.minecraft.diamond_nautilus_armor": "Zirah Genggeng Berlian",
  "item.minecraft.diamond_pickaxe": "Beliung Berlian",
  "item.minecraft.diamond_shovel": "Penyodok Berlian",
  "item.minecraft.diamond_spear": "Tombak Berlian",
  "item.minecraft.diamond_sword": "Pedang Berlian",
  "item.minecraft.disc_fragment_5": "Serpihan Cakera",
  "item.minecraft.disc_fragment_5.desc": "Cakera Muzik - 5",
  "item.minecraft.dolphin_spawn_egg": "Telur Penjelmaan Dolfin",
  "item.minecraft.donkey_spawn_egg": "Telur Penjelmaan Keldai",
  "item.minecraft.dragon_breath": "Nafas Naga",
  "item.minecraft.dried_kelp": "Kelp Kering",
  "item.minecraft.drowned_spawn_egg": "Telur Penjelmaan Lemasan",
  "item.minecraft.dune_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Hiasan Zirah Gumuk",
  "item.minecraft.echo_shard": "Beling Gemaan",
  "item.minecraft.egg": "Telur",
  "item.minecraft.elder_guardian_spawn_egg": "Telur Penjelmaan Penggawa Penjaga",
  "item.minecraft.elytra": "Elitra",
  "item.minecraft.emerald": "Zamrud",
  "item.minecraft.enchanted_book": "Buku Tersihir",
  "item.minecraft.enchanted_golden_apple": "Epal Emas Tersihir",
  "item.minecraft.end_crystal": "Kristal End",
  "item.minecraft.ender_dragon_spawn_egg": "Telur Penjelmaan Naga Ender",
  "item.minecraft.ender_eye": "Mata Ender",
  "item.minecraft.ender_pearl": "Mutiara Ender",
  "item.minecraft.enderman_spawn_egg": "Telur Penjelmaan Enderman",
  "item.minecraft.endermite_spawn_egg": "Telur Penjelmaan Endermite",
  "item.minecraft.evoker_spawn_egg": "Telur Penjelmaan Pawang",
  "item.minecraft.experience_bottle": "Botol Berisi Penyihiran",
  "item.minecraft.explorer_pottery_shard": "Beling Tembikar Penjelajah",
  "item.minecraft.explorer_pottery_sherd": "Beling Tembikar Penjelajah",
  "item.minecraft.eye_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Hiasan Zirah Mata",
  "item.minecraft.feather": "Bulu Pelepah",
  "item.minecraft.fermented_spider_eye": "Mata Labah-labah Ditapai",
  "item.minecraft.field_masoned_banner_pattern": "Corak Panji Bataan",
  "item.minecraft.filled_map": "Peta",
  "item.minecraft.fire_charge": "Bebola Api",
  "item.minecraft.firework_rocket": "Roket Bunga Api",
  "item.minecraft.firework_rocket.flight": "Tempoh Penerbangan:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Bintang Bunga Api",
  "item.minecraft.firework_star.black": "Hitam",
  "item.minecraft.firework_star.blue": "Biru",
  "item.minecraft.firework_star.brown": "Perang",
  "item.minecraft.firework_star.custom_color": "Tersuai",
  "item.minecraft.firework_star.cyan": "Sian",
  "item.minecraft.firework_star.fade_to": "Pudar menjadi",
  "item.minecraft.firework_star.flicker": "Sinar",
  "item.minecraft.firework_star.gray": "Kelabu",
  "item.minecraft.firework_star.green": "Hijau",
  "item.minecraft.firework_star.light_blue": "Biru Muda",
  "item.minecraft.firework_star.light_gray": "Kelabu Muda",
  "item.minecraft.firework_star.lime": "Hijau Muda",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Jingga",
  "item.minecraft.firework_star.pink": "Merah Jambu",
  "item.minecraft.firework_star.purple": "Ungu",
  "item.minecraft.firework_star.red": "Merah",
  "item.minecraft.firework_star.shape": "Bentuk Tak Diketahui",
  "item.minecraft.firework_star.shape.burst": "Meletup",
  "item.minecraft.firework_star.shape.creeper": "Berbentuk Creeper",
  "item.minecraft.firework_star.shape.large_ball": "Bebola Besar",
  "item.minecraft.firework_star.shape.small_ball": "Bebola Halus",
  "item.minecraft.firework_star.shape.star": "Berbentuk Bintang",
  "item.minecraft.firework_star.trail": "Jejak",
  "item.minecraft.firework_star.white": "Putih",
  "item.minecraft.firework_star.yellow": "Kuning",
  "item.minecraft.fishing_rod": "Joran",
  "item.minecraft.flint": "Batu Api",
  "item.minecraft.flint_and_steel": "Pemetik Api",
  "item.minecraft.flow_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Hiasan Zirah Aliran",
  "item.minecraft.flow_banner_pattern": "Corak Panji",
  "item.minecraft.flow_banner_pattern.desc": "Aliran",
  "item.minecraft.flow_banner_pattern.new": "Corak Panji Aliran",
  "item.minecraft.flow_pottery_sherd": "Beling Tembikar Aliran",
  "item.minecraft.flower_banner_pattern": "Corak Panji",
  "item.minecraft.flower_banner_pattern.desc": "Lambang Bunga",
  "item.minecraft.flower_banner_pattern.new": "Corak Panji Lambang Bunga",
  "item.minecraft.flower_pot": "Pasu Bunga",
  "item.minecraft.fox_spawn_egg": "Telur Penjelmaan Rubah",
  "item.minecraft.friend_pottery_shard": "Beling Tembikar Rakan",
  "item.minecraft.friend_pottery_sherd": "Beling Tembikar Rakan",
  "item.minecraft.frog_spawn_egg": "Telur Penjelmaan Katak",
  "item.minecraft.furnace_minecart": "Kereta Lombong dengan Relau",
  "item.minecraft.ghast_spawn_egg": "Telur Penjelmaan Ghast",
  "item.minecraft.ghast_tear": "Air Mata Ghast",
  "item.minecraft.glass_bottle": "Botol Kaca",
  "item.minecraft.glistering_melon_slice": "Potongan Tembikai Berkilauan",
  "item.minecraft.globe_banner_pattern": "Corak Panji",
  "item.minecraft.globe_banner_pattern.desc": "Glob",
  "item.minecraft.globe_banner_pattern.new": "Corak Panji Glob",
  "item.minecraft.glow_berries": "Beri Bersinar",
  "item.minecraft.glow_ink_sac": "Pundi Dakwat Bersinar",
  "item.minecraft.glow_item_frame": "Bingkai Item Bersinar",
  "item.minecraft.glow_squid_spawn_egg": "Telur Penjelmaan Sotong Bersinar",
  "item.minecraft.glowstone_dust": "Serbuk Batu Menyala",
  "item.minecraft.goat_horn": "Tanduk Kambing",
  "item.minecraft.goat_spawn_egg": "Telur Penjelmaan Kambing",
  "item.minecraft.gold_ingot": "Jongkong Emas",
  "item.minecraft.gold_nugget": "Nuget Emas",
  "item.minecraft.golden_apple": "Epal Emas",
  "item.minecraft.golden_axe": "Kapak Emas",
  "item.minecraft.golden_boots": "But Emas",
  "item.minecraft.golden_carrot": "Lobak Emas",
  "item.minecraft.golden_chestplate": "Zirah Dada Emas",
  "item.minecraft.golden_helmet": "Ketopong Emas",
  "item.minecraft.golden_hoe": "Cangkul Emas",
  "item.minecraft.golden_horse_armor": "Zirah Kuda Emas",
  "item.minecraft.golden_leggings": "Zirah Kaki Emas",
  "item.minecraft.golden_nautilus_armor": "Zirah Genggeng Emas",
  "item.minecraft.golden_pickaxe": "Beliung Emas",
  "item.minecraft.golden_shovel": "Penyodok Emas",
  "item.minecraft.golden_spear": "Tombak Emas",
  "item.minecraft.golden_sword": "Pedang Emas",
  "item.minecraft.gray_bundle": "Guni Kelabu",
  "item.minecraft.gray_dye": "Pewarna Kelabu",
  "item.minecraft.gray_harness": "Sela Kelabu",
  "item.minecraft.green_bundle": "Guni Hijau",
  "item.minecraft.green_dye": "Pewarna Hijau",
  "item.minecraft.green_harness": "Sela Hijau",
  "item.minecraft.guardian_spawn_egg": "Telur Penjelmaan Penjaga",
  "item.minecraft.gunpowder": "Serbuk Letupan",
  "item.minecraft.guster_banner_pattern": "Corak Panji",
  "item.minecraft.guster_banner_pattern.desc": "Pemusar",
  "item.minecraft.guster_banner_pattern.new": "Corak Panji Pemusar",
  "item.minecraft.guster_pottery_sherd": "Beling Tembikar Pemusar",
  "item.minecraft.happy_ghast_spawn_egg": "Telur Penjelmaan Ghast Girang",
  "item.minecraft.harness": "Sela",
  "item.minecraft.heart_of_the_sea": "Jiwa Laut",
  "item.minecraft.heart_pottery_shard": "Beling Tembikar Hati",
  "item.minecraft.heart_pottery_sherd": "Beling Tembikar Hati",
  "item.minecraft.heartbreak_pottery_shard": "Beling Tembikar Patah",
  "item.minecraft.heartbreak_pottery_sherd": "Beling Tembikar Patah",
  "item.minecraft.hoglin_spawn_egg": "Telur Penjelmaan Hoglin",
  "item.minecraft.honey_bottle": "Botol Madu",
  "item.minecraft.honeycomb": "Indung Madu",
  "item.minecraft.hopper_minecart": "Kereta Lombong dengan Corong Tuang",
  "item.minecraft.horse_spawn_egg": "Telur Penjelmaan Kuda",
  "item.minecraft.host_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.host_armor_trim_smithing_template.new": "Hiasan Zirah Perumah",
  "item.minecraft.howl_pottery_shard": "Beling Tembikar Deruan",
  "item.minecraft.howl_pottery_sherd": "Beling Tembikar Deruan",
  "item.minecraft.husk_spawn_egg": "Telur Penjelmaan Reputan",
  "item.minecraft.ink_sac": "Pundi Dakwat",
  "item.minecraft.iron_axe": "Kapak Besi",
  "item.minecraft.iron_boots": "But Besi",
  "item.minecraft.iron_chestplate": "Zirah Dada Besi",
  "item.minecraft.iron_golem_spawn_egg": "Telur Penjelmaan Golem Besi",
  "item.minecraft.iron_helmet": "Ketopong Besi",
  "item.minecraft.iron_hoe": "Cangkul Besi",
  "item.minecraft.iron_horse_armor": "Zirah Kuda Besi",
  "item.minecraft.iron_ingot": "Jongkong Besi",
  "item.minecraft.iron_leggings": "Zirah Kaki Besi",
  "item.minecraft.iron_nautilus_armor": "Zirah Genggeng Besi",
  "item.minecraft.iron_nugget": "Nuget Besi",
  "item.minecraft.iron_pickaxe": "Beliung Besi",
  "item.minecraft.iron_shovel": "Penyodok Besi",
  "item.minecraft.iron_spear": "Tombak Besi",
  "item.minecraft.iron_sword": "Pedang Besi",
  "item.minecraft.item_frame": "Bingkai Item",
  "item.minecraft.jungle_boat": "Sampan Rimba",
  "item.minecraft.jungle_chest_boat": "Sampan Rimba dengan Peti",
  "item.minecraft.knowledge_book": "Buku Ilmu",
  "item.minecraft.lapis_lazuli": "Lapis Lazuli",
  "item.minecraft.lava_bucket": "Baldi Lahar",
  "item.minecraft.lead": "Tali Pengikat",
  "item.minecraft.leather": "Kulit",
  "item.minecraft.leather_boots": "But Kulit",
  "item.minecraft.leather_chestplate": "Baju Kulit",
  "item.minecraft.leather_helmet": "Topi Kulit",
  "item.minecraft.leather_horse_armor": "Zirah Kuda Kulit",
  "item.minecraft.leather_leggings": "Seluar Kulit",
  "item.minecraft.light_blue_bundle": "Guni Biru Muda",
  "item.minecraft.light_blue_dye": "Pewarna Biru Muda",
  "item.minecraft.light_blue_harness": "Sela Biru Muda",
  "item.minecraft.light_gray_bundle": "Guni Kelabu Muda",
  "item.minecraft.light_gray_dye": "Pewarna Kelabu Muda",
  "item.minecraft.light_gray_harness": "Sela Kelabu Muda",
  "item.minecraft.lime_bundle": "Guni Hijau Muda",
  "item.minecraft.lime_dye": "Pewarna Hijau Muda",
  "item.minecraft.lime_harness": "Sela Hijau Muda",
  "item.minecraft.lingering_potion": "Posyen Berlarutan",
  "item.minecraft.lingering_potion.effect.awkward": "Posyen Berlarutan Janggal",
  "item.minecraft.lingering_potion.effect.empty": "Posyen Berlarutan yang Tidak Boleh Ditukang",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Posyen Berlarutan Pengalis Api",
  "item.minecraft.lingering_potion.effect.harming": "Posyen Berlarutan Penyakitan",
  "item.minecraft.lingering_potion.effect.healing": "Posyen Berlarutan Penyembuhan",
  "item.minecraft.lingering_potion.effect.infested": "Posyen Berlarutan Pengemutan",
  "item.minecraft.lingering_potion.effect.invisibility": "Posyen Berlarutan Penghalimunan",
  "item.minecraft.lingering_potion.effect.leaping": "Posyen Berlarutan Pelompatan",
  "item.minecraft.lingering_potion.effect.levitation": "Posyen Berlarutan Pengapungan",
  "item.minecraft.lingering_potion.effect.luck": "Posyen Berlarutan Bernasib",
  "item.minecraft.lingering_potion.effect.mundane": "Posyen Berlarutan Biasa",
  "item.minecraft.lingering_potion.effect.night_vision": "Posyen Berlarutan Penglihatan Malam",
  "item.minecraft.lingering_potion.effect.oozing": "Posyen Berlarutan Pelelehan",
  "item.minecraft.lingering_potion.effect.poison": "Posyen Berlarutan Keracunan",
  "item.minecraft.lingering_potion.effect.regeneration": "Posyen Berlarutan Pemulihan",
  "item.minecraft.lingering_potion.effect.slow_falling": "Posyen Berlarutan Kejatuhan Lambat",
  "item.minecraft.lingering_potion.effect.slowness": "Posyen Berlarutan Kelambatan",
  "item.minecraft.lingering_potion.effect.strength": "Posyen Berlarutan Kekuatan",
  "item.minecraft.lingering_potion.effect.swiftness": "Posyen Berlarutan Kelajuan",
  "item.minecraft.lingering_potion.effect.thick": "Posyen Berlarutan Tebal",
  "item.minecraft.lingering_potion.effect.turtle_master": "Posyen Berlarutan Jurupenyu",
  "item.minecraft.lingering_potion.effect.water": "Botol Posyen Berlarutan",
  "item.minecraft.lingering_potion.effect.water_breathing": "Posyen Berlarutan Pernafasan Air",
  "item.minecraft.lingering_potion.effect.weakness": "Posyen Berlarutan Kelemahan",
  "item.minecraft.lingering_potion.effect.weaving": "Posyen Berlarutan Penganyaman",
  "item.minecraft.lingering_potion.effect.wind_charged": "Posyen Berlarutan Pemusar Udara",
  "item.minecraft.llama_spawn_egg": "Telur Penjelmaan Llama",
  "item.minecraft.lodestone_compass": "Kompas Batu Magnet",
  "item.minecraft.mace": "Cokmar",
  "item.minecraft.magenta_bundle": "Guni Magenta",
  "item.minecraft.magenta_dye": "Pewarna Magenta",
  "item.minecraft.magenta_harness": "Sela Magenta",
  "item.minecraft.magma_cream": "Krim Magma",
  "item.minecraft.magma_cube_spawn_egg": "Telur Penjelmaan Kiub Magma",
  "item.minecraft.mangrove_boat": "Sampan Bakau",
  "item.minecraft.mangrove_chest_boat": "Sampan Bakau dengan Peti",
  "item.minecraft.map": "Peta Kosong",
  "item.minecraft.melon_seeds": "Benih Tembikai",
  "item.minecraft.melon_slice": "Hirisan Tembikai",
  "item.minecraft.milk_bucket": "Baldi Susu",
  "item.minecraft.minecart": "Kereta Lombong",
  "item.minecraft.miner_pottery_shard": "Beling Tembikar Pelombong",
  "item.minecraft.miner_pottery_sherd": "Beling Tembikar Pelombong",
  "item.minecraft.mojang_banner_pattern": "Corak Panji",
  "item.minecraft.mojang_banner_pattern.desc": "Benda",
  "item.minecraft.mojang_banner_pattern.new": "Corak Panji Benda",
  "item.minecraft.mooshroom_spawn_egg": "Telur Penjelmaan Mooshroom",
  "item.minecraft.mourner_pottery_shard": "Beling Tembikar Ratapan",
  "item.minecraft.mourner_pottery_sherd": "Beling Tembikar Ratapan",
  "item.minecraft.mule_spawn_egg": "Telur Penjelmaan Baghal",
  "item.minecraft.mushroom_stew": "Stu Cendawan",
  "item.minecraft.music_disc_11": "Cakera Muzik",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Cakera Muzik",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Cakera Muzik",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Cakera Muzik",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Cakera Muzik",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Cakera Muzik",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Cakera Muzik",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Cakera Muzik",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Kotak Muzik)",
  "item.minecraft.music_disc_far": "Cakera Muzik",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Cakera Muzik",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Cakera Muzik",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Cakera Muzik",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Cakera Muzik",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Cakera Muzik",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Cakera Muzik",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Cakera Muzik",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Cakera Muzik",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Cakera Muzik",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Cakera Muzik",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Cakera Muzik",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Cakera Muzik",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Daging Biri-Biri Mentah",
  "item.minecraft.name_tag": "Tag Nama",
  "item.minecraft.nautilus_shell": "Cangkerang Genggeng",
  "item.minecraft.nautilus_spawn_egg": "Telur Penjelmaan Genggeng",
  "item.minecraft.nether_brick": "Bata Nether",
  "item.minecraft.nether_star": "Bintang Nether",
  "item.minecraft.nether_wart": "Ketuat Nether",
  "item.minecraft.netherite_axe": "Kapak Netherit",
  "item.minecraft.netherite_boots": "But Netherit",
  "item.minecraft.netherite_chestplate": "Zirah Dada Netherit",
  "item.minecraft.netherite_helmet": "Ketopong Netherit",
  "item.minecraft.netherite_hoe": "Cangkul Netherit",
  "item.minecraft.netherite_horse_armor": "Zirah Kuda Netherit",
  "item.minecraft.netherite_ingot": "Jongkong Netherit",
  "item.minecraft.netherite_leggings": "Zirah Kaki Netherit",
  "item.minecraft.netherite_nautilus_armor": "Zirah Genggeng Netherit",
  "item.minecraft.netherite_pickaxe": "Beliung Netherit",
  "item.minecraft.netherite_scrap": "Sekerap Netherit",
  "item.minecraft.netherite_shovel": "Penyodok Netherit",
  "item.minecraft.netherite_spear": "Tombak Netherit",
  "item.minecraft.netherite_sword": "Pedang Netherit",
  "item.minecraft.netherite_upgrade_smithing_template": "Templat Tukang Besi",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Naik Taraf Netherit",
  "item.minecraft.oak_boat": "Sampan Oak",
  "item.minecraft.oak_chest_boat": "Sampan Oak dengan Peti",
  "item.minecraft.ocelot_spawn_egg": "Telur Penjelmaan Harimau Oselot",
  "item.minecraft.ominous_bottle": "Botol Mengerikan",
  "item.minecraft.ominous_trial_key": "Kunci Ujian Mengerikan",
  "item.minecraft.orange_bundle": "Guni Jingga",
  "item.minecraft.orange_dye": "Pewarna Jingga",
  "item.minecraft.orange_harness": "Sela Jingga",
  "item.minecraft.painting": "Lukisan",
  "item.minecraft.pale_oak_boat": "Sampan Oak Kemasi",
  "item.minecraft.pale_oak_chest_boat": "Sampan Oak Kemasi dengan Peti",
  "item.minecraft.panda_spawn_egg": "Telur Penjelmaan Panda",
  "item.minecraft.paper": "Kertas",
  "item.minecraft.parched_spawn_egg": "Telur Penjelmaan Keringan",
  "item.minecraft.parrot_spawn_egg": "Telur Penjelmaan Burung Nuri",
  "item.minecraft.phantom_membrane": "Membran Khayalan",
  "item.minecraft.phantom_spawn_egg": "Telur Penjelmaan Khayalan",
  "item.minecraft.pig_spawn_egg": "Telur Penjelmaan Khinzir",
  "item.minecraft.piglin_banner_pattern": "Corak Panji",
  "item.minecraft.piglin_banner_pattern.desc": "Muncung",
  "item.minecraft.piglin_banner_pattern.new": "Corak Panji Muncung",
  "item.minecraft.piglin_brute_spawn_egg": "Telur Penjelmaan Piglin Ganas",
  "item.minecraft.piglin_spawn_egg": "Telur Penjelmaan Piglin",
  "item.minecraft.pillager_spawn_egg": "Telur Penjelmaan Penjarah",
  "item.minecraft.pink_bundle": "Guni Merah Jambu",
  "item.minecraft.pink_dye": "Pewarna Merah Jambu",
  "item.minecraft.pink_harness": "Sela Merah Jambu",
  "item.minecraft.pitcher_plant": "Periuk Kera",
  "item.minecraft.pitcher_pod": "Lenggai Periuk Kera",
  "item.minecraft.plenty_pottery_shard": "Beling Tembikar Kekayaan",
  "item.minecraft.plenty_pottery_sherd": "Beling Tembikar Kekayaan",
  "item.minecraft.poisonous_potato": "Kentang Beracun",
  "item.minecraft.polar_bear_spawn_egg": "Telur Penjelmaan Beruang Kutub",
  "item.minecraft.popped_chorus_fruit": "Bertih Buah Korus",
  "item.minecraft.porkchop": "Daging Khinzir Mentah",
  "item.minecraft.potato": "Kentang",
  "item.minecraft.potion": "Posyen",
  "item.minecraft.potion.effect.awkward": "Posyen Janggal",
  "item.minecraft.potion.effect.empty": "Posyen yang Tidak Boleh Ditukang",
  "item.minecraft.potion.effect.fire_resistance": "Posyen Pengalis Api",
  "item.minecraft.potion.effect.harming": "Posyen Penyakitan",
  "item.minecraft.potion.effect.healing": "Posyen Penyembuhan",
  "item.minecraft.potion.effect.infested": "Posyen Pengemutan",
  "item.minecraft.potion.effect.invisibility": "Posyen Penghalimunan",
  "item.minecraft.potion.effect.leaping": "Posyen Pelompatan",
  "item.minecraft.potion.effect.levitation": "Posyen Pengapungan",
  "item.minecraft.potion.effect.luck": "Posyen Bernasib",
  "item.minecraft.potion.effect.mundane": "Posyen Biasa",
  "item.minecraft.potion.effect.night_vision": "Posyen Penglihatan Malam",
  "item.minecraft.potion.effect.oozing": "Posyen Pelelehan",
  "item.minecraft.potion.effect.poison": "Posyen Keracunan",
  "item.minecraft.potion.effect.regeneration": "Posyen Penyembuhan",
  "item.minecraft.potion.effect.slow_falling": "Posyen Kejatuhan Lambat",
  "item.minecraft.potion.effect.slowness": "Posyen Kelambatan",
  "item.minecraft.potion.effect.strength": "Posyen Kekuatan",
  "item.minecraft.potion.effect.swiftness": "Posyen Kelajuan",
  "item.minecraft.potion.effect.thick": "Posyen Pekat",
  "item.minecraft.potion.effect.turtle_master": "Posyen Jurupenyu",
  "item.minecraft.potion.effect.water": "Botol Air",
  "item.minecraft.potion.effect.water_breathing": "Posyen Pernafasan Air",
  "item.minecraft.potion.effect.weakness": "Posyen Kelemahan",
  "item.minecraft.potion.effect.weaving": "Posyen Penganyaman",
  "item.minecraft.potion.effect.wind_charged": "Posyen Pemusar Udara",
  "item.minecraft.pottery_shard_archer": "Beling Tembikar Pemanah",
  "item.minecraft.pottery_shard_arms_up": "Beling Tembikar Angkat Tangan",
  "item.minecraft.pottery_shard_prize": "Serpihan Tembikar Hadiah",
  "item.minecraft.pottery_shard_skull": "Beling Tembikar Tengkorak",
  "item.minecraft.powder_snow_bucket": "Baldi Salji Serbuk",
  "item.minecraft.prismarine_crystals": "Kristal Prismarin",
  "item.minecraft.prismarine_shard": "Beling Prismarin",
  "item.minecraft.prize_pottery_shard": "Beling Tembikar Hadiah",
  "item.minecraft.prize_pottery_sherd": "Beling Tembikar Hadiah",
  "item.minecraft.pufferfish": "Ikan Buntal",
  "item.minecraft.pufferfish_bucket": "Baldi Ikan Buntal",
  "item.minecraft.pufferfish_spawn_egg": "Telur Penjelmaan Ikan Buntal",
  "item.minecraft.pumpkin_pie": "Pai Labu",
  "item.minecraft.pumpkin_seeds": "Benih Labu",
  "item.minecraft.purple_bundle": "Guni Ungu",
  "item.minecraft.purple_dye": "Pewarna Ungu",
  "item.minecraft.purple_harness": "Sela Ungu",
  "item.minecraft.quartz": "Kuarza Nether",
  "item.minecraft.rabbit": "Arnab Mentah",
  "item.minecraft.rabbit_foot": "Kaki Arnab",
  "item.minecraft.rabbit_hide": "Kulit Arnab",
  "item.minecraft.rabbit_spawn_egg": "Telur Penjelmaan Arnab",
  "item.minecraft.rabbit_stew": "Stu Arnab",
  "item.minecraft.raiser_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Hiasan Zirah Pendukung",
  "item.minecraft.ravager_spawn_egg": "Telur Penjelmaan Pemusnah",
  "item.minecraft.raw_copper": "Tembaga Mentah",
  "item.minecraft.raw_gold": "Emas Mentah",
  "item.minecraft.raw_iron": "Besi Mentah",
  "item.minecraft.recovery_compass": "Kompas Pemulihan",
  "item.minecraft.red_bundle": "Guni Merah",
  "item.minecraft.red_dye": "Pewarna Merah",
  "item.minecraft.red_harness": "Sela Merah",
  "item.minecraft.redstone": "Serbuk Redstone",
  "item.minecraft.resin_brick": "Bata Damar",
  "item.minecraft.resin_clump": "Ketulan Damar",
  "item.minecraft.rib_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Hiasan Zirah Rusuk",
  "item.minecraft.rotten_flesh": "Daging Reput",
  "item.minecraft.saddle": "Pelana",
  "item.minecraft.salmon": "Salmon Mentah",
  "item.minecraft.salmon_bucket": "Baldi Salmon",
  "item.minecraft.salmon_spawn_egg": "Telur Penjelmaan Salmon",
  "item.minecraft.scrape_pottery_sherd": "Beling Tembikar Kikis",
  "item.minecraft.scute": "Skut",
  "item.minecraft.sentry_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Hiasan Zirah Kawal",
  "item.minecraft.shaper_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Hiasan Zirah Penjelma",
  "item.minecraft.sheaf_pottery_shard": "Beling Tembikar Berkas",
  "item.minecraft.sheaf_pottery_sherd": "Beling Tembikar Berkas",
  "item.minecraft.shears": "Pemotong",
  "item.minecraft.sheep_spawn_egg": "Telur Penjelmaan Biri-biri",
  "item.minecraft.shelter_pottery_shard": "Beling Tembikar Teduhan",
  "item.minecraft.shelter_pottery_sherd": "Beling Tembikar Teduhan",
  "item.minecraft.shield": "Perisai",
  "item.minecraft.shield.black": "Perisai Hitam",
  "item.minecraft.shield.blue": "Perisai Biru",
  "item.minecraft.shield.brown": "Perisai Perang",
  "item.minecraft.shield.cyan": "Perisai Sian",
  "item.minecraft.shield.gray": "Perisai Kelabu",
  "item.minecraft.shield.green": "Perisai Hijau",
  "item.minecraft.shield.light_blue": "Perisai Biru Muda",
  "item.minecraft.shield.light_gray": "Perisai Kelabu Muda",
  "item.minecraft.shield.lime": "Perisai Hijau Muda",
  "item.minecraft.shield.magenta": "Perisai Magenta",
  "item.minecraft.shield.orange": "Perisai Jingga",
  "item.minecraft.shield.pink": "Perisai Merah Jambu",
  "item.minecraft.shield.purple": "Perisai Ungu",
  "item.minecraft.shield.red": "Perisai Merah",
  "item.minecraft.shield.white": "Perisai Putih",
  "item.minecraft.shield.yellow": "Perisai Kuning",
  "item.minecraft.shulker_shell": "Cangkerang Shulker",
  "item.minecraft.shulker_spawn_egg": "Telur Penjelmaan Shulker",
  "item.minecraft.sign": "Papan Tanda",
  "item.minecraft.silence_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Hiasan Zirah Diam",
  "item.minecraft.silverfish_spawn_egg": "Telur Penjelmaan Gegat",
  "item.minecraft.skeleton_horse_spawn_egg": "Telur Penjelmaan Kuda Kerangka",
  "item.minecraft.skeleton_spawn_egg": "Telur Penjelmaan Kerangka",
  "item.minecraft.skull_banner_pattern": "Corak Panji",
  "item.minecraft.skull_banner_pattern.desc": "Lambang Tengkorak",
  "item.minecraft.skull_banner_pattern.new": "Corak Panji Lambang Tengkorak",
  "item.minecraft.skull_pottery_shard": "Beling Tembikar Tengkorak",
  "item.minecraft.skull_pottery_sherd": "Beling Tembikar Tengkorak",
  "item.minecraft.slime_ball": "Bebola Lendir",
  "item.minecraft.slime_spawn_egg": "Telur Penjelmaan Lelendir",
  "item.minecraft.smithing_template": "Templat Tukang Besi",
  "item.minecraft.smithing_template.applies_to": "Boleh digunakan pada:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Tambah jongkong atau kristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Zirah",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Tambah zirah",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Jongkong & Kristal",
  "item.minecraft.smithing_template.ingredients": "Bahan-bahan:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Tambah jongkong Netherit",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Kelengkapan Berlian",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Tambah zirah, senjata atau alatan berlian",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Jongkong Netherit",
  "item.minecraft.smithing_template.upgrade": "Naik Taraf: ",
  "item.minecraft.sniffer_spawn_egg": "Telur Penjelmaan Penghidu",
  "item.minecraft.snort_pottery_shard": "Beling Tembikar Hidu",
  "item.minecraft.snort_pottery_sherd": "Beling Tembikar Hidu",
  "item.minecraft.snout_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Hiasan Zirah Muncung",
  "item.minecraft.snow_golem_spawn_egg": "Telur Penjelmaan Golem Salji",
  "item.minecraft.snowball": "Bola Salji",
  "item.minecraft.spectral_arrow": "Anak Panah Spektral",
  "item.minecraft.spider_eye": "Mata Labah-labah",
  "item.minecraft.spider_spawn_egg": "Telur Penjelmaan Labah-labah",
  "item.minecraft.spire_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Hiasan Zirah Ceracak",
  "item.minecraft.splash_potion": "Posyen Percikan",
  "item.minecraft.splash_potion.effect.awkward": "Posyen Percikan Janggal",
  "item.minecraft.splash_potion.effect.empty": "Posyen Percikan yang Tidak Boleh Ditukang",
  "item.minecraft.splash_potion.effect.fire_resistance": "Posyen Percikan Pengalis Api",
  "item.minecraft.splash_potion.effect.harming": "Posyen Percikan Penyakitan",
  "item.minecraft.splash_potion.effect.healing": "Posyen Percikan Penyembuhan",
  "item.minecraft.splash_potion.effect.infested": "Posyen Percikan Pengemutan",
  "item.minecraft.splash_potion.effect.invisibility": "Posyen Percikan Penghalimunan",
  "item.minecraft.splash_potion.effect.leaping": "Posyen Percikan Pelompatan",
  "item.minecraft.splash_potion.effect.levitation": "Posyen Percikan Pengapungan",
  "item.minecraft.splash_potion.effect.luck": "Posyen Percikan Bernasib",
  "item.minecraft.splash_potion.effect.mundane": "Posyen Percikan Biasa",
  "item.minecraft.splash_potion.effect.night_vision": "Posyen Percikan Penglihatan Malam",
  "item.minecraft.splash_potion.effect.oozing": "Posyen Percikan Pelelehan",
  "item.minecraft.splash_potion.effect.poison": "Posyen Percikan Keracunan",
  "item.minecraft.splash_potion.effect.regeneration": "Posyen Percikan Pemulihan",
  "item.minecraft.splash_potion.effect.slow_falling": "Posyen Percikan Kejatuhan Lambat",
  "item.minecraft.splash_potion.effect.slowness": "Posyen Percikan Kelambatan",
  "item.minecraft.splash_potion.effect.strength": "Posyen Percikan Kekuatan",
  "item.minecraft.splash_potion.effect.swiftness": "Posyen Percikan Kelajuan",
  "item.minecraft.splash_potion.effect.thick": "Posyen Percikan Tebal",
  "item.minecraft.splash_potion.effect.turtle_master": "Posyen Percikan Jurupenyu",
  "item.minecraft.splash_potion.effect.water": "Botol Air Percikan",
  "item.minecraft.splash_potion.effect.water_breathing": "Posyen Percikan Pernafasan Air",
  "item.minecraft.splash_potion.effect.weakness": "Posyen Percikan Kelemahan",
  "item.minecraft.splash_potion.effect.weaving": "Posyen Percikan Penganyaman",
  "item.minecraft.splash_potion.effect.wind_charged": "Posyen Percikan Pemusar Udara",
  "item.minecraft.spruce_boat": "Sampan Cemara",
  "item.minecraft.spruce_chest_boat": "Sampan Cemara dengan Peti",
  "item.minecraft.spyglass": "Teropong Kecil",
  "item.minecraft.squid_spawn_egg": "Telur Penjelmaan Sotong",
  "item.minecraft.stick": "Batang Kayu",
  "item.minecraft.stone_axe": "Kapak Batu",
  "item.minecraft.stone_hoe": "Cangkul Batu",
  "item.minecraft.stone_pickaxe": "Beliung Batu",
  "item.minecraft.stone_shovel": "Penyodok Batu",
  "item.minecraft.stone_spear": "Tombak Batu",
  "item.minecraft.stone_sword": "Pedang Batu",
  "item.minecraft.stray_spawn_egg": "Telur Penjelmaan Liaran",
  "item.minecraft.strider_spawn_egg": "Telur Penjelmaan Perentas",
  "item.minecraft.string": "Tali",
  "item.minecraft.sugar": "Gula",
  "item.minecraft.suspicious_stew": "Stu Kesangsian",
  "item.minecraft.sweet_berries": "Beri Manis",
  "item.minecraft.tadpole_bucket": "Baldi Berudu",
  "item.minecraft.tadpole_spawn_egg": "Telur Penjelmaan Berudu",
  "item.minecraft.tide_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Hiasan Zirah Arus",
  "item.minecraft.tipped_arrow": "Anak Panah Disapu",
  "item.minecraft.tipped_arrow.effect.awkward": "Anak Panah Disapu",
  "item.minecraft.tipped_arrow.effect.empty": "Anak Panah Disapu yang Tidak Boleh Ditukang",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Anak Panah Kalis Api",
  "item.minecraft.tipped_arrow.effect.harming": "Anak Panah Memudaratkan",
  "item.minecraft.tipped_arrow.effect.healing": "Anak Panah Penyembuhan",
  "item.minecraft.tipped_arrow.effect.infested": "Anak Panah Pengemutan",
  "item.minecraft.tipped_arrow.effect.invisibility": "Anak Panah Halimunan",
  "item.minecraft.tipped_arrow.effect.leaping": "Anak Panah Lompatan",
  "item.minecraft.tipped_arrow.effect.levitation": "Anak Panah Apungan",
  "item.minecraft.tipped_arrow.effect.luck": "Anak Panah Tuah",
  "item.minecraft.tipped_arrow.effect.mundane": "Anak Panah Disapu",
  "item.minecraft.tipped_arrow.effect.night_vision": "Anak Panah Penglihatan Malam",
  "item.minecraft.tipped_arrow.effect.oozing": "Anak Panah Pelelehan",
  "item.minecraft.tipped_arrow.effect.poison": "Anak Panah Beracun",
  "item.minecraft.tipped_arrow.effect.regeneration": "Anak Panah Penjanaan Semula",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Anak Panah Kejatuhan Lambat",
  "item.minecraft.tipped_arrow.effect.slowness": "Anak Panah Kelambatan",
  "item.minecraft.tipped_arrow.effect.strength": "Anak Panah Kekuatan",
  "item.minecraft.tipped_arrow.effect.swiftness": "Anak Panah Kepantasan",
  "item.minecraft.tipped_arrow.effect.thick": "Anak Panah Disapu",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Anak Panah Mahaguru Penyu",
  "item.minecraft.tipped_arrow.effect.water": "Anak Panah Percikan",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Anak Panah Pernafasan Air",
  "item.minecraft.tipped_arrow.effect.weakness": "Anak Panah Kelemahan",
  "item.minecraft.tipped_arrow.effect.weaving": "Anak Panah Penganyaman",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Anak Panah Pemusar Udara",
  "item.minecraft.tnt_minecart": "Kereta Lombong dengan TNT",
  "item.minecraft.torchflower_seeds": "Benih Tepus Api",
  "item.minecraft.totem_of_undying": "Totem Abadi",
  "item.minecraft.trader_llama_spawn_egg": "Telur Penjelmaan Llama Saudagar",
  "item.minecraft.trial_key": "Kunci Ujian",
  "item.minecraft.trident": "Trisula",
  "item.minecraft.tropical_fish": "Ikan Tropika",
  "item.minecraft.tropical_fish_bucket": "Baldi Ikan Tropika",
  "item.minecraft.tropical_fish_spawn_egg": "Telur Penjelmaan Ikan Tropika",
  "item.minecraft.turtle_helmet": "Karapas Penyu",
  "item.minecraft.turtle_scute": "Skut Penyu",
  "item.minecraft.turtle_spawn_egg": "Telur Penjelmaan Penyu",
  "item.minecraft.vex_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Hiasan Zirah Ganggu",
  "item.minecraft.vex_spawn_egg": "Telur Penjelmaan Bajang",
  "item.minecraft.villager_spawn_egg": "Telur Penjelmaan Penduduk Kampung",
  "item.minecraft.vindicator_spawn_egg": "Telur Penjelmaan Pembela",
  "item.minecraft.wandering_trader_spawn_egg": "Telur Penjelmaan Saudagar Berkelana",
  "item.minecraft.ward_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Hiasan Zirah Jaga",
  "item.minecraft.warden_spawn_egg": "Telur Penjelmaan Penunggu",
  "item.minecraft.warped_fungus_on_a_stick": "Kulat Gila pada Kayu",
  "item.minecraft.water_bucket": "Baldi Air",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Hiasan Zirah Peneroka",
  "item.minecraft.wheat": "Gandum",
  "item.minecraft.wheat_seeds": "Benih Gandum",
  "item.minecraft.white_bundle": "Guni Putih",
  "item.minecraft.white_dye": "Pewarna Putih",
  "item.minecraft.white_harness": "Sela Putih",
  "item.minecraft.wild_armor_trim_smithing_template": "Templat Tukang Besi",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Hiasan Zirah Liar",
  "item.minecraft.wind_charge": "Bebola Angin",
  "item.minecraft.witch_spawn_egg": "Telur Penjelmaan Ahli Sihir",
  "item.minecraft.wither_skeleton_spawn_egg": "Telur Penjelmaan Kerangka Wither",
  "item.minecraft.wither_spawn_egg": "Telur Penjelmaan Wither",
  "item.minecraft.wolf_armor": "Zirah Serigala",
  "item.minecraft.wolf_spawn_egg": "Telur Penjelmaan Serigala",
  "item.minecraft.wooden_axe": "Kapak Kayu",
  "item.minecraft.wooden_hoe": "Cangkul Kayu",
  "item.minecraft.wooden_pickaxe": "Beliung Kayu",
  "item.minecraft.wooden_shovel": "Penyodok Kayu",
  "item.minecraft.wooden_spear": "Tombak Kayu",
  "item.minecraft.wooden_sword": "Pedang Kayu",
  "item.minecraft.writable_book": "Buku dan Bulu Pelepah",
  "item.minecraft.written_book": "Buku Bertulis",
  "item.minecraft.yellow_bundle": "Guni Kuning",
  "item.minecraft.yellow_dye": "Pewarna Kuning",
  "item.minecraft.yellow_harness": "Sela Kuning",
  "item.minecraft.zoglin_spawn_egg": "Telur Penjelmaan Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Telur Penjelmaan Kuda Zombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Telur Penjelmaan Genggeng Zombi",
  "item.minecraft.zombie_spawn_egg": "Telur Penjelmaan Zombi",
  "item.minecraft.zombie_villager_spawn_egg": "Telur Penjelmaan Zombi Penduduk Kampung",
  "item.minecraft.zombified_piglin_spawn_egg": "Telur Penjelmaan Piglin Terzombi"
}
export const ms_my = items; 
